// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.newciis {
  font-family: Montserrat;
}

.excelimg {
  margin-right: 4px;
  height: 15px;
}

.btn-outline-primary-custom {
  color: #17a0b4 !important;
  background-image: none !important;
  background-color: transparent !important;
  border-color: #17a0b4 !important;
}

.intheader {
  font-size: 14px;
  padding-left: 2%;
}

.headercard {
  height: 34px;
  border-radius: 2px;
}

.newintbtndiv {
  padding-left: 6%;
}

.addicon {
  font-size: 19px;
  height: -moz-fit-content;
  height: fit-content;
}

.searchcard {
  border-radius: 2px;
  background-color: #ebebeb;
  font-size: 11px;
}

.proclabel {
  padding-left: 10%;
}

.dircfieldcol {
  padding-right: 24px;
}

.btnsrcexp {
  margin-top: 0%;
  padding-inline: 20%;
  margin-left: -17%;
  height: 27px !important;
}

.targetlabel {
  padding-left: 10%;
}

.targetfieldcol {
  padding-right: 24px;
}

.projlabeltrue {
  padding-left: 12%;
}

.projfielddiv {
  padding-right: 15px;
}

.listcard {
  border-radius: 2px;
}

.todaylabel {
  height: 26px;
}

.todaydivider {
  background-color: rgb(10, 87, 117);
  height: 1px;
}

.yestlabel {
  height: 28px;
}

.todayssuccessdivider {
  background-color: green;
  height: 1px;
}

.todaysinprogdivider {
  background-color: #73731d;
  height: 1px;
}

.todaysfaildivider {
  background-color: #4e0c0c;
  height: 1px;
}

.todaysignoredivider {
  background-color: rgba(128, 128, 128, 0.6901960784);
  height: 1px;
}

.desentity {
  padding-left: 53px;
}

.modebtn {
  height: 17px !important;
  line-height: 9px;
}

.pendingbtn {
  height: 23px;
}

.pendingfileicon {
  font-size: 18px;
  line-height: 14px;
  padding-right: 6px;
  height: auto;
}

.pendingdate {
  padding-top: 1px;
}

.pendingcount {
  padding-right: 1px;
  background-color: #ffd965;
  color: white;
  border-radius: 12px;
}

.pendingcountfail {
  padding-right: 1px;
  background-color: red;
  color: white;
  border-radius: 12px;
}

.checklistdiv {
  width: 90%;
}

.targetidslabel {
  padding-left: 8%;
}

.vendorconlabel {
  padding-left: 98px;
}

::ng-deep.failuremsgpop .modal-dialog {
  max-width: 97% !important;
  max-height: 60% !important;
  height: 60% !important;
  margin: auto !important;
  padding: 0 !important;
}

.btn_stylenewint {
  padding: 2px;
  background-color: #00b050 !important;
  font-size: 12px !important;
  color: white !important;
  height: 25px !important;
  border-radius: 1px;
  width: 100%;
  cursor: pointer;
}

.btn_stylereset {
  padding: 2px;
  background-color: #ebebeb !important;
  font-size: 12px !important;
  color: black !important;
  height: 25px !important;
  border-radius: 1px;
  width: 100%;
  cursor: pointer;
}

.statusdiv {
  padding-left: 4px;
}

::ng-deep .pipeline_feild .autocomplete-container {
  box-shadow: none !important;
  border-radius: 5px !important;
}
::ng-deep .pipeline_feild .autocomplete-container .input-container input {
  border: 1px solid #C0C0C0 !important;
  height: 28px !important;
  width: 100% !important;
}
::ng-deep .pipeline_feild .autocomplete-container .input-container i {
  line-height: 12px !important;
}
::ng-deep .pipeline_feild .autocomplete-container .suggestions-container ul li a {
  padding: 7px 13px !important;
  display: block !important;
  text-decoration: none !important;
  cursor: pointer !important;
  color: rgba(0, 0, 0, 0.87) !important;
  font-size: 12px !important;
}

.datediv {
  border: 1px solid #C0C0C0;
  background-color: white;
  border-radius: 5px;
  height: 28px;
}

.datediv2 {
  border: 1px solid #C0C0C0;
  background-color: white;
  border-radius: 5px;
  height: 28px;
  width: 99%;
  margin-left: 4px;
}

.fromspan {
  padding-right: 6px;
  padding-left: 9px;
  font-size: 11px;
}

.frominput {
  border: transparent;
  font-size: 12px;
}

.tospan {
  padding-right: 3%;
  font-size: 11px;
}

.tospanfail {
  font-size: 11px;
  padding-right: 1% !important;
}

.toinput {
  border: transparent;
  font-size: 12px;
}

.searchbtn {
  margin-top: 7px;
  width: 5%;
  height: 26px !important;
}

.searchicon {
  font-size: 16px !important;
  line-height: 20px !important;
}

.searchdiv {
  display: contents;
}

.leftcol {
  background-color: #f2f2f2;
  height: 84vh;
}

.status {
  width: 100%;
  border-radius: 5px;
  height: 26px;
  font-size: 12px;
  font-family: Montserrat;
}

.direction {
  width: 100%;
  border-radius: 5px;
  height: 28px;
  font-size: 12px;
  border: 1px solid #C0C0C0;
  font-family: Montserrat;
}
.direction option {
  font-family: Montserrat;
  padding: 7px 13px !important;
  display: block !important;
  text-decoration: none !important;
  cursor: pointer !important;
  color: rgba(0, 0, 0, 0.87) !important;
  font-size: 12px !important;
}

.dateselect {
  width: 100%;
  border-radius: 5px;
  height: 28px;
  font-size: 12px;
  border: 1px solid #C0C0C0;
  font-family: Montserrat;
  background-color: #007887;
  color: white;
}
.dateselect option {
  font-family: Montserrat;
  padding: 7px 13px !important;
  background-color: white;
  display: block !important;
  text-decoration: none !important;
  cursor: pointer !important;
  color: rgba(0, 0, 0, 0.87) !important;
  font-size: 12px !important;
}

.dateselect2 {
  width: 80%;
  border-radius: 5px;
  height: 28px;
  font-size: 12px;
  border: 1px solid #C0C0C0;
  font-family: Montserrat;
  background-color: #007887;
  color: white;
  margin-left: 24px !important;
}
.dateselect2 option {
  font-family: Montserrat;
  padding: 7px 13px !important;
  background-color: white;
  display: block !important;
  text-decoration: none !important;
  cursor: pointer !important;
  color: rgba(0, 0, 0, 0.87) !important;
  font-size: 12px !important;
}

.rightcol {
  background-color: white;
  font-size: 12px;
}

.active_card {
  border-left: 4px solid #07a36e;
  width: 99%;
}

.active_cardcolor {
  border-left: 4px solid #07a36e;
  width: 99%;
  background-color: #C3EFF4;
}

.failed_card {
  border-left: 4px solid #da606c;
  width: 99%;
}

.failed_cardcolor {
  border-left: 4px solid #da606c;
  width: 99%;
  background-color: #C3EFF4;
}

.active_img_inbound {
  display: none;
}

.active_img {
  display: none;
}

.inactive_img {
  display: block;
  margin-right: 9px;
  position: relative;
  top: -2px;
}

.inactive_img_inbound {
  display: block;
  margin-right: 11px;
  position: relative;
  top: -2px;
}

.displayNamediv {
  padding-left: 6px;
}

.compare-source-chip-wrap {
  width: 100%;
}

.compare-source-chip {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  max-width: 100%;
  background-color: #fde8e8;
  border-radius: 12px;
  color: #8b1a1a;
  padding: 3px 10px;
  font-size: 13px;
}

.compare-source-chip__label {
  font-weight: 600;
  white-space: nowrap;
}

.compare-source-chip__name {
  max-width: min(60vw, 720px);
  font-weight: 600;
}

.compare-source-chip__close {
  cursor: pointer;
  font-size: 18px;
  height: 18px;
  width: 18px;
  flex-shrink: 0;
  color: #8b1a1a;
}

.compare-source-chip:hover {
  background-color: #f5bcbc;
}

.pipelinenamediv:hover {
  background-color: #3fa4fb;
  border-radius: 12px;
  color: white !important;
  padding: 3px !important;
  cursor: pointer;
}

.assignedUserNamediv:hover {
  background-color: #3fa4fb;
  border-radius: 12px;
  color: white !important;
  padding: 4px !important;
}

.modediv {
  padding-left: 8px;
}

.routeIDdiv {
  padding-left: 6px;
}

.transcountcol {
  padding-inline: 7px;
}

.transcountsuccess {
  background-color: rgba(125, 251, 147, 0.2509803922);
  padding-block: 1px;
  border: 1px solid rgba(0, 128, 0, 0.4901960784);
  font-size: 12px;
}

.transcountinprogress {
  background-color: rgba(253, 242, 102, 0.3490196078);
  padding-block: 1px;
  border: 1px solid #989024;
  font-size: 12px;
}

.transcountfailedto {
  background-color: rgba(255, 128, 128, 0.3019607843);
  padding-block: 1px;
  border: 1px solid rgba(111, 15, 15, 0.6117647059);
  font-size: 12px;
}

.transcountignoredto {
  background-color: rgba(203, 203, 203, 0.69);
  padding-block: 1px;
  border: 1px solid rgba(109, 109, 109, 0.69);
  font-size: 12px;
  border-top-right-radius: 5px;
  border-bottom-right-radius: 5px;
}

.transcountfailedyes {
  background-color: rgba(255, 128, 128, 0.3019607843);
  padding-block: 1px;
  border: 1px solid rgba(111, 15, 15, 0.6117647059);
  font-size: 12px;
  border-bottom-right-radius: 5px;
}

.detailsrouteid {
  border-right: 2px solid #00bcd4;
}

.agents {
  border-right: 2px solid #00bcd4;
}

.datesdiv {
  background-color: #ebebeb;
}

.datedivsize {
  width: 21%;
  padding-left: 31px;
}

.datedivsizemod {
  width: 21%;
  padding-left: 6%;
}

.transadiv {
  color: #17a0b4;
  font-size: 12px;
  margin-top: 3px;
}

.countdate {
  font-size: 12px;
  margin-left: 103px;
}

.countdatediv {
  width: 100px;
  text-align: center;
  border: 1px solid #e6e6e6;
  cursor: pointer;
  text-decoration: underline;
  padding: 15px;
  background-color: #ebebeb;
}

.successmsgheaders {
  width: 100.3px;
  text-align: center;
  border: 1px solid #e6e6e6;
  padding: 15px;
  background-color: #ebebeb;
  font-size: 12px;
}

.msgtitle {
  font-size: 12px;
  width: 100px;
  border: 1px solid #e6e6e6;
  text-align: left;
  padding: 15px;
}

.msgcountdiv {
  width: 100px;
  text-align: center;
  border: 1px solid #e6e6e6;
  padding: 15px;
}

::ng-deep.directiontabs .mat-tab-group.mat-primary .mat-ink-bar {
  background-color: #17a0b4 !important;
  height: 4px !important;
  margin-left: auto;
}

::ng-deep.directiontabs .mat-tab-header {
  height: 33px;
}

::ng-deep.directiontabs .mat-tab-label {
  height: 31px !important;
  text-transform: uppercase;
}

::ng-deep.directiontabs .mat-tab-label .mat-tab-label-content {
  font-size: 12px !important;
  font-weight: 600 !important;
}

::ng-deep.directiontabs .mat-tab-label.mat-ripple.mat-tab-label-active {
  color: #17a0b4 !important;
  background-color: white !important;
  opacity: unset !important;
  font-family: Montserrat;
}
::ng-deep.directiontabs .mat-tab-label.mat-ripple.mat-tab-label-active .outbound_style .active_img {
  display: block !important;
  margin-right: 9px;
  position: relative;
  top: -2px;
}
::ng-deep.directiontabs .mat-tab-label.mat-ripple.mat-tab-label-active .outbound_style .inactive_img {
  display: none !important;
}
::ng-deep.directiontabs .mat-tab-label.mat-ripple.mat-tab-label-active .inbound_style .active_img_inbound {
  display: block !important;
  margin-right: 11px;
  position: relative;
  top: -2px;
}
::ng-deep.directiontabs .mat-tab-label.mat-ripple.mat-tab-label-active .inbound_style .inactive_img_inbound {
  display: none !important;
}

.directionlist {
  font-size: 11px;
  font-family: Montserrat;
  min-height: 66vh !important;
  max-height: 66vh !important;
  overflow-x: hidden !important;
  overflow-y: auto !important;
}

.directionlistexp {
  font-size: 11px;
  font-family: Montserrat;
  min-height: 47vh !important;
  max-height: 47vh !important;
  overflow-x: hidden !important;
  overflow-y: auto !important;
}

.dedisplayname {
  color: #17a0b4;
  font-weight: bold;
  border-right: 2px solid #00bcd4;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.dividerline {
  background-color: #17a0b4;
  height: 3px;
  width: 100%;
  margin-top: 10px;
}

.highchart {
  border: 2px solid #007887;
  font-size: 12px;
  min-height: 280px;
  max-height: 280px;
  margin-left: 4%;
}

.highcharts-figure,
.highcharts-data-table table {
  min-width: 310px;
  max-width: 310px;
  margin: 1em auto;
}

#container {
  height: 200px;
}

.highcharts-data-table table {
  font-family: Verdana, sans-serif;
  border-collapse: collapse;
  border: 1px solid #ebebeb;
  margin: 10px auto;
  text-align: center;
  width: 100%;
  max-width: 300px;
}

.highcharts-data-table caption {
  padding: 1em 0;
  font-size: 1.2em;
  color: #555;
}

.highcharts-data-table th {
  font-weight: 600;
  padding: 0.5em;
}

.highcharts-data-table td,
.highcharts-data-table th,
.highcharts-data-table caption {
  padding: 0.5em;
}

.highcharts-data-table thead tr,
.highcharts-data-table tr:nth-child(even) {
  background: #f8f8f8;
}

.highcharts-data-table tr:hover {
  background: #f1f7ff;
}

.failresbody {
  min-height: 255px;
  max-height: 255px;
  overflow-x: hidden !important;
  overflow-y: auto !important;
  border-bottom: 2px solid #007887;
  border-left: 2px solid #007887;
  border-right: 2px solid #007887;
  border-radius: 2px;
}

.failrestitle {
  font-size: 12px;
  color: white;
  border-radius: 2px;
}

.failres {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  text-decoration: underline;
  cursor: pointer;
}

.failresdiv {
  margin-left: 25px;
  padding-right: 33px;
}

.lockicon {
  font-size: 18px;
  color: #ff5d00;
  height: auto;
}

.ids {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  font-size: 12px;
  font-family: Montserrat;
  width: 36%;
  padding-left: 4%;
}

.vendorids {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  font-size: 12px;
  font-family: Montserrat;
  width: 35%;
}

.vendoridsmail {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  font-size: 12px;
  font-family: Montserrat;
  width: 36%;
  padding-left: 34px;
}

.vendoridsph {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  font-size: 12px;
  font-family: Montserrat;
  width: 36%;
  padding-left: 4%;
}

.vendormaillabel {
  padding-left: 8%;
}

.idspop {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  font-size: 12px;
  font-family: Montserrat;
  width: 36%;
  padding-left: 1%;
}

.idsproc {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  font-size: 12px;
  font-family: Montserrat;
  width: 42%;
  padding-left: 40px;
  padding-right: 80px;
}

.idsproj {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  font-size: 12px;
  font-family: Montserrat;
  width: 42%;
  padding-left: 7%;
}

.idslab {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  font-size: 12px;
  font-family: Montserrat;
  width: 38%;
  padding-left: 77px;
  padding-right: 6%;
}

.pipelineidsdiv {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  font-size: 12px;
  font-family: Montserrat;
  width: 38%;
  padding-right: 6%;
  padding-left: 54px;
}

.idsfac {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  font-size: 12px;
  font-family: Montserrat;
  width: 34%;
  padding-left: 26px;
}

.projlabel {
  padding-left: 28px;
}

.fontcolr {
  color: #17a0b4;
}

.failresbodypop {
  overflow-x: hidden !important;
  overflow-y: auto !important;
  border-bottom: 2px solid #007887;
  border-left: 2px solid #007887;
  border-right: 2px solid #007887;
  min-height: 278px;
  max-height: 278px;
}

.successresbody {
  min-height: 255px;
  max-height: 255px;
  border-bottom: 2px solid #007887;
  border-left: 2px solid #007887;
  border-right: 2px solid #007887;
  border-radius: 2px;
}

.successreslist {
  overflow-x: hidden !important;
  overflow-y: auto !important;
  min-height: 232px;
  max-height: 232px;
}

.failurelistheader {
  background-color: #007887;
  font-size: 12px;
  color: white;
  font-family: Montserrat;
}

::ng-deep.failresbodypop .mat-checkbox-frame {
  border: 1px solid #007887;
}

::ng-deep.failresbodypop .mat-checkbox-inner-container {
  height: 15px;
}

::ng-deep.failurelistheader .mat-checkbox-frame {
  border: 1px solid #007887;
}

::ng-deep.failurelistheader .mat-checkbox-inner-container {
  height: 15px;
  background-color: white;
}

.reprobtn {
  background-color: #007887;
  font-size: 12px;
  color: white;
  font-family: Montserrat;
  cursor: pointer;
}

.popupdate {
  border-left: 2px solid #00bcd4;
  border-right: 2px solid #00bcd4;
}

.reason {
  font-size: 13px;
  color: #17a0b4;
  font-weight: bold;
  font-family: Montserrat;
}

.headercheckbox {
  padding-left: calc(1vw + 3px);
}

.chevronleft {
  line-height: 36px;
  top: 14px;
  position: relative;
}

.chevronleftbtnact {
  background-color: green;
  color: white;
  margin-left: 1%;
}

.chevronleftbtninact {
  background-color: red;
  color: white;
  margin-left: 1%;
}

.failresheader {
  background-color: #007887;
}

.countdateheader {
  background-color: #007887;
  height: 22px;
  width: 100%;
  margin-left: 0px;
}

.modal .modalsize {
  max-width: 90% !important;
}

::ng-deep.idsexpdiv .idsacc .mat-expansion-panel-body {
  padding: 5px !important;
  background-color: #ebebeb !important;
  font-size: 12px;
}

.msgcountday {
  background-color: #17a2b8;
  color: white;
}

.main {
  height: 17px;
  border-radius: 0 0 100px 100px;
  border: 1px solid grey;
  border-top: none;
  background-clip: padding-box;
  position: relative;
  display: inline-block;
  margin-right: 6px;
  padding-inline: 3px;
  position: relative;
  top: 9px;
}

.submain {
  height: 17px;
  border-radius: 0 0 100px 100px;
  border: 1px solid grey;
  border-top: none;
  background-clip: padding-box;
  position: relative;
  display: inline-block;
  margin-right: 6px;
  padding-inline: 3px;
  position: relative;
  top: 9px;
}

.main::after {
  content: "";
  position: absolute;
  left: 100%;
  right: 1px;
  height: 1px;
  border-top: 1px solid grey;
  width: 33%;
  display: inline;
  top: 0;
}

.img_space {
  height: 23px;
  position: relative;
  top: -12px;
}

.varulebtn {
  height: 23px !important;
}

.connheadersdef {
  bottom: 7%;
  position: relative;
  background-color: #ebebeb;
  color: black;
  border: 1px solid;
  border-radius: 1px;
  left: 14%;
  width: 70%;
}

.details2 {
  background-color: white;
  overflow-x: hidden !important;
  overflow-y: auto !important;
  min-height: 64vh;
  max-height: 64vh;
}

::ng-deep.connec .mat-tab-label {
  min-width: 16.66% !important;
  max-width: 16.66% !important;
  border-right: 2px solid #ebebeb !important;
}

::ng-deep.interface .Failed {
  min-width: 16.66% !important;
  max-width: 16.66% !important;
  border-right: 2px solid #ebebeb !important;
  background-color: red;
  color: white;
}

::ng-deep.connec .Success.mat-tab-label {
  min-width: 16.66% !important;
  max-width: 16.66% !important;
  border-right: 2px solid #ebebeb !important;
  background-color: green !important;
  color: white !important;
}

::ng-deep.connec .default .mat-tab-label {
  min-width: 16.66% !important;
  max-width: 16.66% !important;
  border-right: 2px solid #ebebeb !important;
}

::ng-deep.connec .mat-tab-group.mat-primary .mat-ink-bar {
  background-color: #17a0b4 !important;
  height: 4px !important;
  margin-left: auto;
}

.stepper-wrapper {
  display: flex;
  justify-content: space-between;
  height: 82vh;
  overflow-x: hidden;
}

.stepper-item {
  position: relative;
  font-size: 11px;
  display: flex;
  flex-direction: column;
  align-items: center;
  flex: 1;
  background-color: #ebebeb;
  border: 2px solid rgba(200, 197, 197, 0.2196078431);
  min-width: 16.66%;
  max-width: 16.66%;
}

.cursor {
  cursor: pointer;
}

.seqheader {
  min-width: 16.66% !important;
  max-width: 16.66% !important;
  border: 2px solid #ebebeb !important;
  height: 33px;
  padding: 5px;
  text-align: center;
  opacity: 0.5;
}

.seqheaderActive {
  opacity: unset;
  box-shadow: 1px 0px 7px 1px grey;
}

.Failed {
  background-color: #f59598 !important;
  color: white !important;
}

.Success {
  background-color: #90cfb5 !important;
  color: white !important;
}

.default {
  min-width: 16.66% !important;
  max-width: 16.66% !important;
  border: 2px solid #ebebeb !important;
  height: 33px;
  padding: 5px;
  text-align: center;
  opacity: 0.5;
}

.seqbody {
  overflow-x: hidden !important;
  overflow-y: auto !important;
  min-height: 120px;
  max-height: 120px;
  background-color: rgba(169, 218, 209, 0.3215686275);
}

.datediviconsize {
  padding-left: 4%;
  width: 14%;
}

.form-control {
  border-radius: 5px !important;
  font-size: 11px !important;
}

.failurelistheader1 {
  font-size: 12px;
  color: black;
  font-family: Montserrat;
}

.mat-mdc-table {
  width: 100%;
  max-height: 100px;
  overflow: auto;
}

.mat-column-name {
  height: 100px;
}

.datavalidtableheader {
  position: sticky;
  top: 0;
  background-color: #0e6470;
  z-index: 1;
  color: white;
  height: 23px;
  display: flex;
  justify-content: center;
  align-items: center;
}

.content-row {
  margin-top: 30px; /* Adjust the margin as needed */
}

.even-row {
  background-color: #F0F0F0;
}

.odd-row {
  background-color: #FFFFFF;
}

.even-row,
.odd-row {
  height: 33px;
  display: flex;
  justify-content: center;
  align-items: center;
}

.container::-webkit-scrollbar {
  width: 8px;
  background-color: #f5f5f5;
}

.mat-form-field-appearance-outline .mat-form-field-infix {
  width: 221px;
}

.callsplit {
  margin-right: 5px;
  color: #f44455;
}

.scrollable-content {
  position: absolute;
  top: 20px; /* Adjust this value to match the height of the sticky row */
  bottom: 0;
  left: 0;
  right: 0;
  overflow-x: hidden;
}

::ng-deep .ValidationPopupScreen .modal-dialog {
  max-width: 80%;
  max-height: 60% !important;
  height: 60% !important;
  margin: auto !important;
  padding: 0 !important;
}

.Header_row {
  background: #007887;
  margin-inline: -0.5px;
  color: white;
}

/* Add the styles for the scrolling div */
.card-scroll {
  height: 387px; /* Adjust the height as needed */
  overflow-x: hidden;
}

.selected {
  background-color: #B8FAFF; /* Add your desired background color for the selected card */
}

.isCompletedStatus {
  cursor: pointer;
}

.visibility_off {
  color: #17a2b8;
  height: 19px !important;
  width: 19px !important;
  font-size: 19px;
  padding-left: 13px;
  position: relative;
  top: 1px;
  cursor: pointer;
}

.visibility {
  color: #17a2b8;
  height: 19px !important;
  width: 19px !important;
  font-size: 19px;
  cursor: pointer;
}

.failrow .msgtitle {
  background-color: #ffc3c3;
}

.failrow .msgcountdiv {
  background-color: #ffc3c3;
}

.ignorerow .msgtitle {
  background-color: #fffdbe;
}

.ignorerow .msgcountdiv {
  background-color: #fffdbe;
}

.successrow .msgtitle {
  background-color: #c4fba0;
}

.successrow .msgcountdiv {
  background-color: #c4fba0;
}

.resolvedrow .msgtitle {
  background-color: #c6ecff;
}

.resolvedrow .msgcountdiv {
  background-color: #c6ecff;
}

.datedivpop {
  border: 1px solid #C0C0C0;
  background-color: white;
  border-radius: 5px;
  height: 24px;
  width: 49%;
}

.toinputpop {
  border: transparent;
  font-size: 12px;
  height: 20px;
}

.frominputpop {
  border: transparent;
  font-size: 12px;
  height: 20px;
}

.datesearchpopbtn {
  background-color: #59a7b1;
  color: white;
  height: 24px;
  width: 28px;
  padding-left: 1px;
}

.copy_iconss {
  background-repeat: no-repeat;
  display: inline-block;
  fill: currentColor;
  font-size: 16px;
  position: relative;
  top: 8%;
  left: 2%;
  cursor: pointer;
}

.mat-icon-button ::ng-deep .mat-button-focus-overlay {
  display: none;
}

::ng-deep.myint.mat-mdc-checkbox {
  height: 16px;
  width: 16px;
  position: relative;
  right: 100%;
  bottom: 42%;
}
::ng-deep.myint.mat-mdc-checkbox .mdc-checkbox {
  width: 14px;
  height: 14px;
}
::ng-deep.myint.mat-mdc-checkbox .mdc-checkbox .mdc-checkbox__native-control:enabled:checked ~ .mdc-checkbox__background {
  border-color: #17a0b4 !important;
  background-color: #17a0b4 !important;
}
::ng-deep.myint.mat-mdc-checkbox .mdc-checkbox .mdc-checkbox__native-control:enabled ~ .mdc-checkbox__background .mdc-checkbox__checkmark {
  color: white;
}
::ng-deep.myint.mat-mdc-checkbox .mdc-checkbox__background {
  height: 16px;
  width: 16px;
}

.msgmodaldata {
  min-height: 55vh !important;
  max-height: 55vh !important;
  overflow-x: hidden !important;
  overflow-y: auto !important;
}

::ng-deep.moreicon .mat-mdc-button-persistent-ripple {
  display: none !important;
}

.autocomplete-dropdown {
  position: absolute;
  background-color: #fff;
  border: 1px solid #ccc;
  max-height: 200px;
  overflow-y: auto;
  z-index: 1000;
  border-radius: 6px !important;
}

.autocomplete-dropdown ul {
  list-style-type: none;
  padding: 0;
  margin: 0;
  color: black;
}

.autocomplete-dropdown li {
  padding: 8px;
  cursor: pointer;
}

.autocomplete-dropdown li:hover {
  background-color: #f0f0f0;
}

.input-wrapper {
  position: relative;
  display: flex;
  align-items: center;
}

.loading-spinner {
  position: absolute;
  top: 50%;
  right: 10px;
  transform: translateY(-50%);
  pointer-events: none;
}

.mat-spinner {
  width: 20px;
  height: 20px;
}

.pipeline_feild .autocomplete-container .x {
  display: none;
}

.clear-icon {
  position: absolute;
  right: 0%;
  cursor: pointer;
  color: rgba(0, 0, 0, 0.54);
  top: 20%;
  font-size: 18px !important;
}

.redirectlink:hover {
  background-color: #3fa4fb;
  border-radius: 12px;
  color: white;
  padding: 3px;
  cursor: pointer;
  height: 21px;
}

.interfacepagination .mat-mdc-paginator {
  background-color: #f1f1f1 !important;
}

.pinned-section {
  margin-top: 10px;
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.pinned-card {
  border-left: 4px solid #2196f3;
  background-color: #f7f9fc;
  transition: all 0.3s ease;
}

.pinned-card:hover {
  background-color: #eaf2fb;
}

.child-card-section {
  margin-left: 30px; /* visually nested */
  border-left: 3px solid #cfd8dc;
  padding-left: 10px;
  margin-top: 5px;
}

.child-card {
  background: #ffffff; /* subtle gray background */
  border-radius: 6px;
  border: 1px solid #e0e0e0; /* thin border to separate rows */
  margin-bottom: 4px;
  transition: all 0.3s ease;
}

.child-card:hover {
  background: #f1f1f1;
}

.child-card .row {
  font-size: 13px;
  color: #333;
}

.child-card b {
  color: #007bff;
}

.childexpcard {
  background-color: #f9f9f9;
  margin-bottom: 0;
  padding-top: 5px;
  min-height: 13vh;
  max-height: 23vh;
  overflow-x: hidden;
  overflow-y: auto;
}

.searchkey {
  white-space: nowrap;
  position: relative;
  z-index: 1000;
  color: #4b86b2;
}

.searchkey:hover {
  background-color: #3fa4fb;
  border-radius: 12px;
  color: white;
  padding: 3px;
  cursor: pointer;
  white-space: nowrap;
  position: relative;
  z-index: 1000;
}

.expander-icon {
  color: #ffffff !important;
  font-size: 20px !important;
  width: 20px !important;
  height: 20px !important;
  display: inline-block !important;
  line-height: 20px !important;
  position: relative !important;
  z-index: 100 !important;
}

.addconfigbtn {
  overflow: visible !important;
}
.addconfigbtn .expander-icon {
  z-index: 100 !important;
}

::ng-deep.myCustomModalClassciisint .modal-dialog {
  max-width: 97%;
  max-height: 60%;
  height: 60%;
  margin: auto;
  padding: 0 !important;
}

.pin-icon-container {
  width: 60px;
  height: 42px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 2px;
  cursor: pointer;
}

.pin-icon {
  color: #17a0b4 !important;
  font-size: 20px !important;
  width: 20px !important;
  height: 20px !important;
  line-height: 20px !important;
  display: inline-block !important;
}

.pin-label {
  color: #17a0b4;
  font-size: 10px;
  white-space: nowrap;
  line-height: 1.2;
  font-family: Montserrat, sans-serif;
}

.interface-menu-item-inline {
  display: flex !important;
  flex-direction: row !important;
  align-items: center !important;
  justify-content: flex-start !important;
  flex-wrap: nowrap !important;
  min-height: 40px !important;
}

.interface-menu-item-inline__row {
  display: flex;
  flex-direction: row;
  align-items: center;
  flex-wrap: nowrap;
  width: 100%;
  min-width: 0;
  gap: 12px;
}

.interface-menu-item-inline__icon-slot {
  width: 20px;
  height: 20px;
  flex-shrink: 0;
  display: inline-flex;
  align-items: center;
  justify-content: center;
}
.interface-menu-item-inline__icon-slot mat-icon {
  font-size: 20px;
  width: 20px;
  height: 20px;
  line-height: 20px;
  color: #007887;
}
.interface-menu-item-inline__icon-slot svg,
.interface-menu-item-inline__icon-slot img {
  width: 16px;
  height: 16px;
  display: block;
  color: #007887;
  fill: currentColor;
  object-fit: contain;
}

.interface-menu-item-inline__icon {
  flex-shrink: 0;
  color: #007887;
  display: block;
}

.interface-menu-item-inline__label {
  font-size: 12px;
  white-space: nowrap;
  line-height: 1.2;
}

::ng-deep .interface-pipeline-menu .mat-mdc-menu-item {
  min-height: 40px;
  padding-inline: 12px;
}
::ng-deep .interface-pipeline-menu .mat-mdc-menu-item-text {
  display: flex;
  align-items: center;
  width: 100%;
}

/* --- ADDED (does not remove or edit the existing .details2 / .directionlist rules above) ---
   Nested scroll surfaces (e.g. agent/detail area .details2) sit inside the tab shell.
   Global locks on .mat-drawer-content alone do not stop these; use :host-context so we win
   over local !important overflow rules when a child overlay is open
   (VA Rules = NgbModal, Delivery rules = MatDialog). */
:host-context(body.modal-open) .details2,
:host-context(body.app-main-scroll-locked) .details2,
:host-context(html.cdk-global-scrollblock) .details2,
:host-context(body.modal-open) .directionlist,
:host-context(body.app-main-scroll-locked) .directionlist,
:host-context(html.cdk-global-scrollblock) .directionlist,
:host-context(body.modal-open) .directionlistexp,
:host-context(body.app-main-scroll-locked) .directionlistexp,
:host-context(html.cdk-global-scrollblock) .directionlistexp {
  overflow: hidden !important;
}`, "",{"version":3,"sources":["webpack://./src/app/CIIS/interface/interface.component.scss","webpack://./src/variables.scss"],"names":[],"mappings":"AACA;EACI,uBAAA;AAAJ;;AAEA;EACE,iBAAA;EAAkB,YAAA;AAEpB;;AAAA;EACE,yBAAA;EACA,iCAAA;EACA,wCAAA;EACA,gCAAA;AAGF;;AADA;EACE,eAAA;EAAgB,gBAAA;AAKlB;;AAHA;EACE,YAAA;EAAa,kBAAA;AAOf;;AALA;EACE,gBAAA;AAQF;;AANA;EACE,eAAA;EAAgB,wBAAA;EAAA,mBAAA;AAUlB;;AARA;EACE,kBAAA;EAAqB,yBAAA;EAA0B,eAAA;AAajD;;AAXA;EACE,iBAAA;AAcF;;AAZA;EACE,mBAAA;AAeF;;AAbA;EACE,cAAA;EAAe,mBAAA;EAAoB,iBAAA;EAAkB,uBAAA;AAmBvD;;AAjBA;EACE,iBAAA;AAoBF;;AAlBA;EACE,mBAAA;AAqBF;;AAnBA;EACE,iBAAA;AAsBF;;AAnBA;EACE,mBAAA;AAsBF;;AApBA;EACE,kBAAA;AAuBF;;AArBA;EACE,YAAA;AAwBF;;AAtBA;EACE,kCAAA;EAAiC,WAAA;AA0BnC;;AAxBA;EACE,YAAA;AA2BF;;AAzBA;EACE,uBAAA;EAAwB,WAAA;AA6B1B;;AA3BA;EACE,yBAAA;EAA0B,WAAA;AA+B5B;;AA7BA;EACE,yBAAA;EAA0B,WAAA;AAiC5B;;AA/BA;EACE,mDAAA;EAAoD,WAAA;AAmCtD;;AAjCA;EACE,kBAAA;AAoCF;;AAlCA;EACE,uBAAA;EAAwB,gBAAA;AAsC1B;;AApCA;EACE,YAAA;AAuCF;;AArCA;EACE,eAAA;EAAgB,iBAAA;EAAkB,kBAAA;EAAmB,YAAA;AA2CvD;;AAzCA;EACE,gBAAA;AA4CF;;AA1CA;EACE,kBAAA;EAAmB,yBAAA;EAA0B,YAAA;EAAa,mBAAA;AAgD5D;;AA9CA;EACE,kBAAA;EAAmB,qBAAA;EAAqB,YAAA;EAAa,mBAAA;AAoDvD;;AAlDA;EACE,UAAA;AAqDF;;AAnDA;EACE,gBAAA;AAsDF;;AAnDA;EACE,kBAAA;AAsDF;;AAlDA;EACE,yBAAA;EACA,0BAAA;EACA,sBAAA;EACA,uBAAA;EACA,qBAAA;AAqDF;;AAnDA;EACE,YAAA;EACA,oCAAA;EACA,0BAAA;EACA,uBAAA;EACA,uBAAA;EACA,kBAAA;EACA,WAAA;EACA,eAAA;AAsDF;;AApDA;EACE,YAAA;EACA,oCAAA;EACA,0BAAA;EACA,uBAAA;EACA,uBAAA;EACA,kBAAA;EACA,WAAA;EACA,eAAA;AAuDF;;AArDA;EACE,iBAAA;AAwDF;;AAtDA;EACI,2BAAA;EACA,6BAAA;AAyDJ;AAxDI;EACI,oCAAA;EACA,uBAAA;EACA,sBAAA;AA0DR;AAxDI;EACI,4BAAA;AA0DR;AAvDI;EACI,4BAAA;EACA,yBAAA;EACA,gCAAA;EACA,0BAAA;EACA,qCAAA;EACA,0BAAA;AAyDR;;AArDA;EACI,yBAAA;EACA,uBAAA;EACA,kBAAA;EACA,YAAA;AAwDJ;;AAtDA;EACE,yBAAA;EACA,uBAAA;EACA,kBAAA;EACA,YAAA;EACA,UAAA;EACA,gBAAA;AAyDF;;AAvDA;EACA,kBAAA;EACA,iBAAA;EACA,eAAA;AA0DA;;AAxDA;EACA,mBAAA;EACA,eAAA;AA2DA;;AAzDA;EACI,iBAAA;EACA,eAAA;AA4DJ;;AA1DA;EACE,eAAA;EACA,4BAAA;AA6DF;;AA3DA;EACA,mBAAA;EACA,eAAA;AA8DA;;AA5DA;EACI,eAAA;EACA,SAAA;EACA,uBAAA;AA+DJ;;AA7DA;EACI,0BAAA;EACA,4BAAA;AAgEJ;;AA9DA;EACI,iBAAA;AAiEJ;;AA/DA;EACA,yBAAA;EACA,YAAA;AAkEA;;AAhEA;EACI,WAAA;EACA,kBAAA;EACA,YAAA;EACA,eAAA;EACA,uBAAA;AAmEJ;;AAjEA;EACE,WAAA;EACA,kBAAA;EACA,YAAA;EACA,eAAA;EACA,yBAAA;EACA,uBAAA;AAoEF;AAnEE;EACE,uBAAA;EACE,4BAAA;EACA,yBAAA;EACA,gCAAA;EACA,0BAAA;EACA,qCAAA;EACA,0BAAA;AAqEN;;AAlEA;EACE,WAAA;EACA,kBAAA;EACA,YAAA;EACA,eAAA;EACA,yBAAA;EACA,uBAAA;EACA,yBAAA;EACA,YAAA;AAqEF;AApEE;EACE,uBAAA;EACE,4BAAA;EACA,uBAAA;EACA,yBAAA;EACA,gCAAA;EACA,0BAAA;EACA,qCAAA;EACA,0BAAA;AAsEN;;AAnEA;EACE,UAAA;EACA,kBAAA;EACA,YAAA;EACA,eAAA;EACA,yBAAA;EACA,uBAAA;EACA,yBAAA;EACA,YAAA;EACA,4BAAA;AAsEF;AArEE;EACE,uBAAA;EACE,4BAAA;EACA,uBAAA;EACA,yBAAA;EACA,gCAAA;EACA,0BAAA;EACA,qCAAA;EACA,0BAAA;AAuEN;;AApEI;EACA,uBAAA;EACA,eAAA;AAuEJ;;AArEI;EACE,8BAAA;EACA,UAAA;AAwEN;;AAtEI;EACE,8BAAA;EACA,UAAA;EAAW,yBAAA;AA0EjB;;AAxEI;EACE,8BAAA;EACA,UAAA;AA2EN;;AAzEI;EACE,8BAAA;EACA,UAAA;EAAW,yBAAA;AA6EjB;;AA3EA;EACE,aAAA;AA8EF;;AA5EA;EACE,aAAA;AA+EF;;AA7EA;EACE,cAAA;EACA,iBAAA;EACA,kBAAA;EACA,SAAA;AAgFF;;AA9EA;EACE,cAAA;EACA,kBAAA;EACA,kBAAA;EACA,SAAA;AAiFF;;AA/EA;EACE,iBAAA;AAkFF;;AAhFA;EACE,WAAA;AAmFF;;AAhFA;EACE,oBAAA;EACA,mBAAA;EACA,QAAA;EACA,eAAA;EACA,yBAAA;EACA,mBAAA;EACA,cAAA;EACA,iBAAA;EACA,eAAA;AAmFF;;AAhFA;EACE,gBAAA;EACA,mBAAA;AAmFF;;AAhFA;EACE,2BAAA;EACA,gBAAA;AAmFF;;AAhFA;EACE,eAAA;EACA,eAAA;EACA,YAAA;EACA,WAAA;EACA,cAAA;EACA,cAAA;AAmFF;;AAhFA;EACE,yBAAA;AAmFF;;AA9EA;EACE,yBAAA;EACA,mBAAA;EACA,uBAAA;EACA,uBAAA;EACA,eAAA;AAiFF;;AA7EA;EACE,yBAAA;EACA,mBAAA;EACA,uBAAA;EACA,uBAAA;AAgFF;;AA7EA;EACE,iBAAA;AAgFF;;AA9EA;EACE,iBAAA;AAiFF;;AA/EA;EACE,mBAAA;AAkFF;;AA/EA;EACE,mDAAA;EAA4B,kBAAA;EAAmB,+CAAA;EAA4B,eAAA;AAqF7E;;AAnFA;EACE,mDAAA;EAA4B,kBAAA;EAAmB,yBAAA;EAA0B,eAAA;AAyF3E;;AAvFA;EACE,mDAAA;EAA4B,kBAAA;EAAmB,iDAAA;EAA4B,eAAA;AA6F7E;;AA3FA;EACE,2CAAA;EAAyC,kBAAA;EAAmB,2CAAA;EAA4C,eAAA;EACxG,4BAAA;EACA,+BAAA;AAiGF;;AA/FA;EACE,mDAAA;EAA4B,kBAAA;EAAmB,iDAAA;EAA4B,eAAA;EAC3E,+BAAA;AAqGF;;AAnGA;EACE,+BAAA;AAsGF;;AApGA;EACE,+BAAA;AAuGF;;AArGA;EACE,yBAAA;AAwGF;;AAtGA;EACE,UAAA;EAAW,kBAAA;AA0Gb;;AAxGA;EACE,UAAA;EAAW,gBAAA;AA4Gb;;AA1GA;EACE,cAAA;EAAgB,eAAA;EAAgB,eAAA;AA+GlC;;AA7GA;EACE,eAAA;EAAgB,kBAAA;AAiHlB;;AA9GA;EACE,YAAA;EACA,kBAAA;EACA,yBAAA;EACA,eAAA;EACA,0BAAA;EACA,aAAA;EACA,yBAAA;AAiHF;;AA/GA;EACE,cAAA;EACA,kBAAA;EACA,yBAAA;EACA,aAAA;EACA,yBAAA;EACA,eAAA;AAkHF;;AAhHA;EACE,eAAA;EACA,YAAA;EACA,yBAAA;EACA,gBAAA;EACA,aAAA;AAmHF;;AAhHA;EACE,YAAA;EACA,kBAAA;EACA,yBAAA;EACA,aAAA;AAmHF;;AAjHA;EACE,oCAAA;EACA,sBAAA;EACA,iBAAA;AAoHF;;AAlHA;EACE,YAAA;AAqHF;;AAnHA;EACE,uBAAA;EACA,yBAAA;AAsHF;;AAnHA;EACE,0BAAA;EACA,2BAAA;AAsHF;;AApHE;EACI,yBAAA;EACA,kCAAA;EACA,yBAAA;EACA,uBAAA;AAuHN;AArHQ;EACE,yBAAA;EACA,iBAAA;EACA,kBAAA;EACA,SAAA;AAuHV;AArHQ;EACE,wBAAA;AAuHV;AAnHQ;EACE,yBAAA;EACA,kBAAA;EACA,kBAAA;EACA,SAAA;AAqHV;AAnHQ;EACE,wBAAA;AAqHV;;AAjHI;EACE,eAAA;EACA,uBAAA;EAEF,2BAAA;EACA,2BAAA;EACA,6BAAA;EACA,2BAAA;AAmHJ;;AAjHI;EACE,eAAA;EACA,uBAAA;EAEF,2BAAA;EACA,2BAAA;EACA,6BAAA;EACA,2BAAA;AAmHJ;;AAjHI;EACA,cAAA;EACA,iBAAA;EACA,+BAAA;EACA,gBAAA;EACF,uBAAA;EACA,mBAAA;AAoHF;;AAjHI;EACA,yBAAA;EACA,WAAA;EACA,WAAA;EACA,gBAAA;AAoHJ;;AAjHA;EACE,yBAAA;EACE,eAAA;EACA,iBAAA;EACA,iBAAA;EACA,eAAA;AAoHJ;;AAjHI;;EAEF,gBAAA;EACA,gBAAA;EACA,gBAAA;AAoHF;;AAjHA;EACE,aAAA;AAoHF;;AAjHA;EACE,gCAAA;EACA,yBAAA;EACA,yBAAA;EACA,iBAAA;EACA,kBAAA;EACA,WAAA;EACA,gBAAA;AAoHF;;AAjHA;EACE,cAAA;EACA,gBAAA;EACA,WAAA;AAoHF;;AAjHA;EACE,gBAAA;EACA,cAAA;AAoHF;;AAjHA;;;EAGE,cAAA;AAoHF;;AAjHA;;EAEE,mBAAA;AAoHF;;AAjHA;EACE,mBAAA;AAoHF;;AAlHA;EACE,iBAAA;EAAkB,iBAAA;EACnB,6BAAA;EAA8B,2BAAA;EAC7B,gCAAA;EACA,8BAAA;EACA,+BAAA;EACA,kBAAA;AAuHF;;AArHA;EACE,eAAA;EAAgB,YAAA;EAAa,kBAAA;AA0H/B;;AAxHA;EACE,gBAAA;EACA,uBAAA;EACA,mBAAA;EACA,0BAAA;EACA,eAAA;AA2HF;;AAzHA;EACE,iBAAA;EAAkB,mBAAA;AA6HpB;;AA3HA;EACE,eAAA;EACE,cAAA;EACA,YAAA;AA8HJ;;AA5HA;EACE,gBAAA;EACF,uBAAA;EACA,mBAAA;EACA,eAAA;EACA,uBAAA;EACA,UAAA;EACA,gBAAA;AA+HA;;AA7HA;EACE,gBAAA;EACA,uBAAA;EACA,mBAAA;EACA,eAAA;EACA,uBAAA;EACA,UAAA;AAgIF;;AA9HA;EACE,gBAAA;EACA,uBAAA;EACA,mBAAA;EACA,eAAA;EACA,uBAAA;EACA,UAAA;EACA,kBAAA;AAiIF;;AA/HA;EACE,gBAAA;EACA,uBAAA;EACA,mBAAA;EACA,eAAA;EACA,uBAAA;EACA,UAAA;EACA,gBAAA;AAkIF;;AAhIA;EACE,gBAAA;AAmIF;;AAjIA;EACE,gBAAA;EACF,uBAAA;EACA,mBAAA;EACA,eAAA;EACA,uBAAA;EACA,UAAA;EACA,gBAAA;AAoIA;;AAlIA;EACE,gBAAA;EACF,uBAAA;EACA,mBAAA;EACA,eAAA;EACA,uBAAA;EACA,UAAA;EACA,kBAAA;EACA,mBAAA;AAqIA;;AAnIA;EACE,gBAAA;EACF,uBAAA;EACA,mBAAA;EACA,eAAA;EACA,uBAAA;EACA,UAAA;EACA,gBAAA;AAsIA;;AApIA;EACA,gBAAA;EACA,uBAAA;EACA,mBAAA;EACA,eAAA;EACA,uBAAA;EACA,UAAA;EACA,kBAAA;EACA,iBAAA;AAuIA;;AArIA;EACE,gBAAA;EACA,uBAAA;EACA,mBAAA;EACA,eAAA;EACA,uBAAA;EACA,UAAA;EACA,iBAAA;EACA,kBAAA;AAwIF;;AArIA;EACE,gBAAA;EACF,uBAAA;EACA,mBAAA;EACA,eAAA;EACA,uBAAA;EACA,UAAA;EACA,kBAAA;AAwIA;;AAtIA;EACE,kBAAA;AAyIF;;AAvIA;EACE,cAAA;AA0IF;;AAxIA;EAEE,6BAAA;EACA,2BAAA;EACA,gCAAA;EACA,8BAAA;EACA,+BAAA;EACA,iBAAA;EACA,iBAAA;AA0IF;;AAxIA;EACE,iBAAA;EAAkB,iBAAA;EAClB,gCAAA;EACA,8BAAA;EACA,+BAAA;EACA,kBAAA;AA4IF;;AAzIA;EACE,6BAAA;EAA8B,2BAAA;EAC9B,iBAAA;EAAkB,iBAAA;AA8IpB;;AA5IA;EACE,yBAAA;EAA0B,eAAA;EAAgB,YAAA;EAAa,uBAAA;AAkJzD;;AA/IA;EACE,yBAAA;AAkJF;;AAhJA;EACE,YAAA;AAmJF;;AAjJA;EACE,yBAAA;AAoJF;;AAlJA;EACE,YAAA;EACA,uBAAA;AAqJF;;AAnJA;EACE,yBAAA;EAA0B,eAAA;EAAgB,YAAA;EAAa,uBAAA;EAAwB,eAAA;AA0JjF;;AAxJA;EACE,8BAAA;EACA,+BAAA;AA2JF;;AAzJA;EAIE,eAAA;EACA,cAAA;EACA,iBAAA;EACA,uBAAA;AAyJF;;AAtJA;EACE,6BAAA;AAyJF;;AAvJA;EACI,iBAAA;EACA,SAAA;EACA,kBAAA;AA0JJ;;AAxJA;EACE,uBAAA;EAAwB,YAAA;EAAa,eAAA;AA6JvC;;AA3JA;EACE,qBAAA;EAAsB,YAAA;EAAa,eAAA;AAgKrC;;AA9JA;EACA,yBAAA;AAiKA;;AA/JA;EACE,yBAAA;EACA,YAAA;EACA,WAAA;EACA,gBAAA;AAkKF;;AAhKA;EACE,yBAAA;AAmKF;;AAjKA;EACE,uBAAA;EACA,oCAAA;EACA,eAAA;AAoKF;;AAlKA;EACE,yBAAA;EACA,YAAA;AAqKF;;AAlKA;EAGE,YAAA;EACA,8BAAA;EACA,sBAAA;EACA,gBAAA;EACA,4BAAA;EACA,kBAAA;EACA,qBAAA;EACA,iBAAA;EACA,mBAAA;EACA,kBAAA;EACA,QAAA;AAmKF;;AA/JA;EAGE,YAAA;EACA,8BAAA;EACA,sBAAA;EACA,gBAAA;EACA,4BAAA;EACA,kBAAA;EACA,qBAAA;EACA,iBAAA;EACA,mBAAA;EACA,kBAAA;EACA,QAAA;AAgKF;;AA5JA;EACE,WAAA;EACA,kBAAA;EACA,UAAA;EACA,UAAA;EACA,WAAA;EACA,0BAAA;EACA,UAAA;EACA,eAAA;EACA,MAAA;AA+JF;;AA7JA;EACE,YAAA;EACA,kBAAA;EACA,UAAA;AAgKF;;AA9JA;EACE,uBAAA;AAiKF;;AA/JA;EACE,UAAA;EACA,kBAAA;EACA,yBAAA;EACA,YAAA;EACA,iBAAA;EACA,kBAAA;EACA,SAAA;EACA,UAAA;AAkKF;;AAhKA;EACE,uBAAA;EACA,6BAAA;EAA8B,2BAAA;EAA4B,gBAAA;EAAgB,gBAAA;AAsK5E;;AApKA;EACE,4BAAA;EACA,4BAAA;EACA,0CAAA;AAuKF;;AArKA;EACE,4BAAA;EACA,4BAAA;EACA,0CAAA;EACA,qBAAA;EACA,YAAA;AAwKF;;AAtKA;EACE,4BAAA;EACA,4BAAA;EACA,0CAAA;EACA,kCAAA;EACA,uBAAA;AAyKF;;AAvKA;EACE,4BAAA;EACA,4BAAA;EACA,0CAAA;AA0KF;;AAxKA;EACE,oCAAA;EACA,sBAAA;EACA,iBAAA;AA2KF;;AAxKA;EACE,aAAA;EACA,8BAAA;EACA,YAAA;EACA,kBAAA;AA2KF;;AAzKA;EACE,kBAAA;EACA,eAAA;EACA,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,OAAA;EACA,yBAAA;EACA,mDAAA;EACA,iBAAA;EACA,iBAAA;AA4KF;;AA1KA;EACE,eAAA;AA6KF;;AAxKA;EACE,4BAAA;EACA,4BAAA;EACA,oCAAA;EACA,YAAA;EACA,YAAA;EACA,kBAAA;EACA,YAAA;AA2KF;;AAzKA;EACE,cAAA;EACA,gCAAA;AA4KF;;AA1KA;EACE,oCAAA;EACA,uBAAA;AA6KF;;AA3KA;EACE,oCAAA;EACA,uBAAA;AA8KF;;AA5KA;EACE,4BAAA;EACA,4BAAA;EACA,oCAAA;EACA,YAAA;EACA,YAAA;EACA,kBAAA;EACA,YAAA;AA+KF;;AA3KA;EACE,6BAAA;EACA,2BAAA;EACA,iBAAA;EACA,iBAAA;EACA,mDAAA;AA8KF;;AA5KA;EACE,gBAAA;EACA,UAAA;AA+KF;;AA7KA;EACE,6BAAA;EACA,0BAAA;AAgLF;;AA3KA;EACE,eAAA;EAAgB,YAAA;EAAa,uBAAA;AAgL/B;;AA7KA;EACE,WAAA;EACA,iBAAA;EACA,cAAA;AAgLF;;AA7KA;EACE,aAAA;AAgLF;;AA5KA;EACE,gBAAA;EACA,MAAA;EACA,yBAAA;EACA,UAAA;EACA,YAAA;EACA,YAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;AA+KF;;AA5KA;EACE,gBAAA,EAAA,gCAAA;AA+KF;;AA7KA;EACE,yBAAA;AAgLF;;AA7KA;EACE,yBAAA;AAgLF;;AA9KA;;EAEE,YAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;AAiLF;;AA9KA;EACE,UAAA;EACA,yBAAA;AAiLF;;AA9KA;EACE,YAAA;AAiLF;;AA9KA;EAEE,iBAAA;EACA,cAAA;AAgLF;;AA9KA;EACE,kBAAA;EACA,SAAA,EAAA,4DAAA;EACA,SAAA;EACA,OAAA;EACA,QAAA;EACA,kBAAA;AAiLF;;AA7KA;EACE,cAAA;EACA,0BAAA;EACA,sBAAA;EACA,uBAAA;EACA,qBAAA;AAgLF;;AA7KA;EACE,mBAAA;EACA,qBAAA;EACA,YAAA;AAgLF;;AA9KA,yCAAA;AACA;EACE,aAAA,EAAA,gCAAA;EACA,kBAAA;AAiLF;;AA9KA;EACE,yBAAA,EAAA,4DAAA;AAiLF;;AA9KA;EACE,eAAA;AAiLF;;AA/KA;EACE,cAAA;EACA,uBAAA;EACA,sBAAA;EACA,eAAA;EACA,kBAAA;EACA,kBAAA;EACA,QAAA;EACA,eAAA;AAkLF;;AAhLA;EACE,cAAA;EACA,uBAAA;EACA,sBAAA;EACA,eAAA;EACA,eAAA;AAmLF;;AAjLA;EACE,yBAAA;AAoLF;;AAlLA;EACE,yBAAA;AAqLF;;AAnLA;EACE,yBAAA;AAsLF;;AApLA;EACE,yBAAA;AAuLF;;AArLA;EACE,yBAAA;AAwLF;;AAtLA;EACE,yBAAA;AAyLF;;AAvLA;EACE,yBAAA;AA0LF;;AAxLA;EACE,yBAAA;AA2LF;;AAzLA;EACE,yBAAA;EACA,uBAAA;EACA,kBAAA;EACA,YAAA;EACA,UAAA;AA4LF;;AA1LA;EACA,mBAAA;EACA,eAAA;EACA,YAAA;AA6LA;;AA3LA;EACE,mBAAA;EACA,eAAA;EACA,YAAA;AA8LF;;AA5LE;EACE,yBAAA;EACA,YAAA;EACA,YAAA;EACA,WAAA;EACA,iBAAA;AA+LJ;;AA7LE;EACE,4BAAA;EACE,qBAAA;EACA,kBAAA;EACA,eAAA;EACA,kBAAA;EACA,OAAA;EACA,QAAA;EACA,eAAA;AAgMN;;AA9LE;EACE,aAAA;AAiMJ;;AA/LA;EACE,YAAA;EACA,WAAA;EACA,kBAAA;EACA,WAAA;EACA,WAAA;AAkMF;AAjME;EACE,WAAA;EACA,YAAA;AAmMJ;AAlMI;EACE,gCCzoCM;ED0oCN,oCC1oCM;AD80CZ;AAlMI;EACE,YAAA;AAoMN;AAjME;EACE,YAAA;EACA,WAAA;AAmMJ;;AAhMA;EACE,2BAAA;EACA,2BAAA;EACA,6BAAA;EACA,2BAAA;AAmMF;;AAjMA;EACA,wBAAA;AAoMA;;AAjMA;EACE,kBAAA;EACA,sBAAA;EACA,sBAAA;EACA,iBAAA;EACA,gBAAA;EAEA,aAAA;EACA,6BAAA;AAmMF;;AAhMA;EACE,qBAAA;EACA,UAAA;EACA,SAAA;EACA,YAAA;AAmMF;;AAhMA;EACE,YAAA;EACA,eAAA;AAmMF;;AAhMA;EACE,yBAAA;AAmMF;;AAhMA;EACE,kBAAA;EACA,aAAA;EACA,mBAAA;AAmMF;;AAhMA;EACE,kBAAA;EACA,QAAA;EACA,WAAA;EACA,2BAAA;EACA,oBAAA;AAmMF;;AAhMA;EACE,WAAA;EACA,YAAA;AAmMF;;AAhMA;EACE,aAAA;AAmMF;;AAhMA;EACE,kBAAA;EACA,SAAA;EACA,eAAA;EACA,0BAAA;EACA,QAAA;EACA,0BAAA;AAmMF;;AA9KA;EACE,yBAAA;EACE,mBAAA;EACA,YAAA;EACA,YAAA;EACA,eAAA;EACA,YAAA;AAiLJ;;AA9KE;EACE,oCAAA;AAiLJ;;AA7KA;EACE,gBAAA;EACA,aAAA;EACA,sBAAA;EACA,QAAA;AAgLF;;AA7KA;EACE,8BAAA;EACA,yBAAA;EACA,yBAAA;AAgLF;;AA7KA;EACE,yBAAA;AAgLF;;AA7KA;EACE,iBAAA,EAAA,oBAAA;EACA,8BAAA;EACA,kBAAA;EACA,eAAA;AAgLF;;AA7KA;EACE,mBAAA,EAAA,2BAAA;EACA,kBAAA;EACA,yBAAA,EAAA,iCAAA;EACA,kBAAA;EACA,yBAAA;AAgLF;;AA7KA;EACE,mBAAA;AAgLF;;AA7KA;EACE,eAAA;EACA,WAAA;AAgLF;;AA7KA;EACE,cAAA;AAgLF;;AA7KA;EACE,yBAAA;EACA,gBAAA;EACA,gBAAA;EACA,gBAAA;EACA,gBAAA;EACA,kBAAA;EACA,gBAAA;AAgLF;;AA7KA;EACE,mBAAA;EAAsB,kBAAA;EAAoB,aAAA;EAC1C,cAAA;AAkLF;;AAhLA;EACE,yBAAA;EACE,mBAAA;EACA,YAAA;EACA,YAAA;EACA,eAAA;EACA,mBAAA;EACA,kBAAA;EAAoB,aAAA;AAoLxB;;AAjLA;EACE,yBAAA;EACA,0BAAA;EACA,sBAAA;EACA,uBAAA;EACA,gCAAA;EACA,4BAAA;EACA,6BAAA;EACA,uBAAA;AAoLF;;AAjLA;EACE,4BAAA;AAoLF;AAlLE;EACE,uBAAA;AAoLJ;;AAjLA;EACE,cAAA;EACA,eAAA;EACA,WAAA;EACA,YAAA;EACA,qBAAA;AAoLF;;AAhLA;EACE,WAAA;EACA,YAAA;EACA,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,uBAAA;EACA,QAAA;EACA,eAAA;AAmLF;;AA/KA;EACE,yBAAA;EACA,0BAAA;EACA,sBAAA;EACA,uBAAA;EACA,4BAAA;EACA,gCAAA;AAkLF;;AA9KA;EACE,cAAA;EACA,eAAA;EACA,mBAAA;EACA,gBAAA;EACA,mCAAA;AAiLF;;AA9KA;EACE,wBAAA;EACA,8BAAA;EACA,8BAAA;EACA,sCAAA;EACA,4BAAA;EACA,2BAAA;AAiLF;;AA/KA;EACE,aAAA;EACA,mBAAA;EACA,mBAAA;EACA,iBAAA;EACA,WAAA;EACA,YAAA;EACA,SAAA;AAkLF;;AAhLA;EACE,WAAA;EACA,YAAA;EACA,cAAA;EACA,oBAAA;EACA,mBAAA;EACA,uBAAA;AAmLF;AAjLE;EACE,eAAA;EACA,WAAA;EACA,YAAA;EACA,iBAAA;EACA,cAAA;AAmLJ;AAhLE;;EAEE,WAAA;EACA,YAAA;EACA,cAAA;EACA,cAAA;EACA,kBAAA;EACA,mBAAA;AAkLJ;;AA/KA;EACE,cAAA;EACA,cAAA;EACA,cAAA;AAkLF;;AAhLA;EACE,eAAA;EACA,mBAAA;EACA,gBAAA;AAmLF;;AA/KE;EACE,gBAAA;EACA,oBAAA;AAkLJ;AA/KE;EACE,aAAA;EACA,mBAAA;EACA,WAAA;AAiLJ;;AA7KA;;;;uDAAA;AAKA;;;;;;;;;EASE,2BAAA;AAgLF","sourcesContent":["@import \"../../../variables.scss\";\r\n.newciis{\r\n    font-family: Montserrat;\r\n}\r\n.excelimg{\r\n  margin-right: 4px;height: 15px;\r\n}\r\n.btn-outline-primary-custom {\r\n  color: #17a0b4 !important;\r\n  background-image: none !important;\r\n  background-color: transparent !important;\r\n  border-color: #17a0b4 !important;\r\n}\r\n.intheader{\r\n  font-size: 14px;padding-left: 2%;\r\n}\r\n.headercard{\r\n  height: 34px;border-radius: 2px;\r\n}\r\n.newintbtndiv{\r\n  padding-left: 6%;\r\n}\r\n.addicon{\r\n  font-size: 19px;height: fit-content;\r\n}\r\n.searchcard{\r\n  border-radius: 2px;  background-color: #ebebeb;font-size: 11px;\r\n}\r\n.proclabel{\r\n  padding-left: 10%;\r\n}\r\n.dircfieldcol{\r\n  padding-right:24px;\r\n}\r\n.btnsrcexp{\r\n  margin-top: 0%;padding-inline: 20%;margin-left: -17%;height: 27px !important;\r\n}\r\n.targetlabel{\r\n  padding-left: 10%;\r\n}\r\n.targetfieldcol{\r\n  padding-right: 24px;\r\n}\r\n.projlabeltrue{\r\n  padding-left: 12%;\r\n}\r\n\r\n.projfielddiv{\r\n  padding-right: 15px;\r\n}\r\n.listcard{\r\n  border-radius: 2px;\r\n}\r\n.todaylabel{\r\n  height: 26px;\r\n}\r\n.todaydivider{\r\n  background-color: rgb(10 87 117);height: 1px;\r\n}\r\n.yestlabel{\r\n  height: 28px;\r\n}\r\n.todayssuccessdivider{\r\n  background-color: green;height: 1px;\r\n}\r\n.todaysinprogdivider{\r\n  background-color: #73731d;height: 1px;\r\n}\r\n.todaysfaildivider{\r\n  background-color: #4e0c0c;height: 1px;\r\n}\r\n.todaysignoredivider{\r\n  background-color: rgba(128, 128, 128, 0.6901960784);height: 1px;\r\n}\r\n.desentity{\r\n  padding-left: 53px;\r\n}\r\n.modebtn{\r\n  height: 17px !important;line-height: 9px;\r\n}\r\n.pendingbtn{\r\n  height: 23px;\r\n}\r\n.pendingfileicon{\r\n  font-size: 18px;line-height: 14px;padding-right: 6px;height: auto;\r\n}\r\n.pendingdate{\r\n  padding-top:1px\r\n}\r\n.pendingcount{\r\n  padding-right: 1px;background-color: #ffd965;color: white;border-radius: 12px;\r\n}\r\n.pendingcountfail{\r\n  padding-right: 1px;background-color:red;color: white;border-radius: 12px;\r\n}\r\n.checklistdiv{\r\n  width:90%\r\n}\r\n.targetidslabel{\r\n  padding-left: 8%;\r\n}\r\n\r\n.vendorconlabel{\r\n  padding-left: 98px;\r\n}\r\n\r\n\r\n::ng-deep.failuremsgpop .modal-dialog {\r\n  max-width: 97%!important;\r\n  max-height: 60%!important;\r\n  height: 60%!important;\r\n  margin: auto!important;\r\n  padding: 0 !important;\r\n}\r\n.btn_stylenewint{\r\n  padding: 2px;\r\n  background-color: #00b050 !important;\r\n  font-size: 12px !important;\r\n  color: white !important;\r\n  height: 25px !important;\r\n  border-radius: 1px;\r\n  width: 100%;\r\n  cursor: pointer;\r\n}\r\n.btn_stylereset{\r\n  padding: 2px;\r\n  background-color: #ebebeb !important;\r\n  font-size: 12px !important;\r\n  color: black !important;\r\n  height: 25px !important;\r\n  border-radius: 1px;\r\n  width: 100%;\r\n  cursor: pointer;\r\n}\r\n.statusdiv{\r\n  padding-left: 4px;\r\n}\r\n::ng-deep .pipeline_feild .autocomplete-container{\r\n    box-shadow: none !important;\r\n    border-radius: 5px !important;\r\n    .input-container input{\r\n        border: 1px solid #C0C0C0 !important;\r\n        height: 28px !important;\r\n        width: 100% !important;\r\n    }\r\n    .input-container i{\r\n        line-height: 12px !important;\r\n    }\r\n   \r\n    .suggestions-container ul li a {\r\n        padding: 7px 13px !important;\r\n        display: block !important;\r\n        text-decoration: none !important;\r\n        cursor: pointer !important;\r\n        color: rgba(0, 0, 0, 0.87) !important;\r\n        font-size: 12px !important;\r\n    }\r\n}\r\n\r\n.datediv{\r\n    border: 1px solid #C0C0C0;\r\n    background-color: white;\r\n    border-radius: 5px;\r\n    height: 28px;\r\n}\r\n.datediv2{\r\n  border: 1px solid #C0C0C0;\r\n  background-color: white;\r\n  border-radius: 5px;\r\n  height: 28px;\r\n  width: 99%;\r\n  margin-left: 4px;\r\n}\r\n.fromspan{\r\npadding-right: 6px;\r\npadding-left: 9px;\r\nfont-size: 11px;\r\n}\r\n.frominput{\r\nborder: transparent;\r\nfont-size: 12px;\r\n}\r\n.tospan{\r\n    padding-right:3%;\r\n    font-size: 11px;\r\n}\r\n.tospanfail{\r\n  font-size: 11px;\r\n  padding-right: 1% !important;\r\n}\r\n.toinput{\r\nborder:transparent;\r\nfont-size: 12px;\r\n}\r\n.searchbtn{\r\n    margin-top: 7px;\r\n    width: 5%;\r\n    height: 26px !important;\r\n}\r\n.searchicon{\r\n    font-size: 16px !important;\r\n    line-height: 20px !important;\r\n}\r\n.searchdiv{\r\n    display: contents;\r\n}\r\n.leftcol{\r\nbackground-color: #f2f2f2;\r\nheight: 84vh;\r\n}\r\n.status{\r\n    width: 100%;\r\n    border-radius: 5px;\r\n    height: 26px;\r\n    font-size: 12px;\r\n    font-family: Montserrat;\r\n}\r\n.direction{\r\n  width: 100%;\r\n  border-radius: 5px;\r\n  height: 28px;\r\n  font-size: 12px;\r\n  border: 1px solid #C0C0C0;\r\n  font-family: Montserrat;\r\n  option{\r\n    font-family: Montserrat;\r\n      padding: 7px 13px !important;\r\n      display: block !important;\r\n      text-decoration: none !important;\r\n      cursor: pointer !important;\r\n      color: rgba(0, 0, 0, 0.87) !important;\r\n      font-size: 12px !important;\r\n  }\r\n}\r\n.dateselect{\r\n  width: 100%;\r\n  border-radius: 5px;\r\n  height: 28px;\r\n  font-size: 12px;\r\n  border: 1px solid #C0C0C0;\r\n  font-family: Montserrat;\r\n  background-color: #007887;\r\n  color: white;\r\n  option{\r\n    font-family: Montserrat;\r\n      padding: 7px 13px !important;\r\n      background-color: white;\r\n      display: block !important;\r\n      text-decoration: none !important;\r\n      cursor: pointer !important;\r\n      color: rgba(0, 0, 0, 0.87) !important;\r\n      font-size: 12px !important;\r\n  }\r\n}\r\n.dateselect2{\r\n  width: 80%;\r\n  border-radius: 5px;\r\n  height: 28px;\r\n  font-size: 12px;\r\n  border: 1px solid #C0C0C0;\r\n  font-family: Montserrat;\r\n  background-color: #007887;\r\n  color: white;\r\n  margin-left: 24px !important;\r\n  option{\r\n    font-family: Montserrat;\r\n      padding: 7px 13px !important;\r\n      background-color: white;\r\n      display: block !important;\r\n      text-decoration: none !important;\r\n      cursor: pointer !important;\r\n      color: rgba(0, 0, 0, 0.87) !important;\r\n      font-size: 12px !important;\r\n  }\r\n}\r\n    .rightcol{\r\n    background-color: white;\r\n    font-size: 12px;\r\n    }\r\n    .active_card {\r\n      border-left: 4px solid #07a36e;\r\n      width: 99%;\r\n    }\r\n    .active_cardcolor{\r\n      border-left: 4px solid #07a36e;\r\n      width: 99%;background-color: #C3EFF4;\r\n    }\r\n    .failed_card {\r\n      border-left: 4px solid #da606c;\r\n      width: 99%;\r\n    }\r\n    .failed_cardcolor {\r\n      border-left: 4px solid #da606c;\r\n      width: 99%;background-color: #C3EFF4;\r\n    }\r\n.active_img_inbound{\r\n  display: none;\r\n}\r\n.active_img{\r\n  display: none;\r\n}\r\n.inactive_img{\r\n  display: block;\r\n  margin-right: 9px;\r\n  position: relative;\r\n  top: -2px;\r\n}\r\n.inactive_img_inbound{\r\n  display: block;\r\n  margin-right: 11px;\r\n  position: relative;\r\n  top: -2px;\r\n}\r\n.displayNamediv{\r\n  padding-left: 6px;\r\n}\r\n.compare-source-chip-wrap {\r\n  width: 100%;\r\n}\r\n\r\n.compare-source-chip {\r\n  display: inline-flex;\r\n  align-items: center;\r\n  gap: 8px;\r\n  max-width: 100%;\r\n  background-color: #fde8e8;\r\n  border-radius: 12px;\r\n  color: #8b1a1a;\r\n  padding: 3px 10px;\r\n  font-size: 13px;\r\n}\r\n\r\n.compare-source-chip__label {\r\n  font-weight: 600;\r\n  white-space: nowrap;\r\n}\r\n\r\n.compare-source-chip__name {\r\n  max-width: min(60vw, 720px);\r\n  font-weight: 600;\r\n}\r\n\r\n.compare-source-chip__close {\r\n  cursor: pointer;\r\n  font-size: 18px;\r\n  height: 18px;\r\n  width: 18px;\r\n  flex-shrink: 0;\r\n  color: #8b1a1a;\r\n}\r\n\r\n.compare-source-chip:hover {\r\n  background-color: #f5bcbc;\r\n}\r\n\r\n.pipelinenamediv{\r\n}\r\n.pipelinenamediv:hover{\r\n  background-color: #3fa4fb;\r\n  border-radius: 12px;\r\n  color: white !important;\r\n  padding: 3px !important;\r\n  cursor: pointer;\r\n}\r\n.assignedUserNamediv{\r\n}\r\n.assignedUserNamediv:hover{\r\n  background-color: #3fa4fb;\r\n  border-radius: 12px;\r\n  color: white !important;\r\n  padding: 4px !important;\r\n}\r\n\r\n.modediv{\r\n  padding-left: 8px;\r\n}\r\n.routeIDdiv{\r\n  padding-left: 6px;\r\n}\r\n.transcountcol{\r\n  padding-inline: 7px;\r\n}\r\n\r\n.transcountsuccess{\r\n  background-color: #7dfb9340;padding-block: 1px;border: 1px solid #0080007d;font-size: 12px;\r\n}\r\n.transcountinprogress{\r\n  background-color: #fdf26659;padding-block: 1px;border: 1px solid #989024;font-size: 12px;\r\n}\r\n.transcountfailedto{\r\n  background-color: #ff80804d;padding-block: 1px;border: 1px solid #6f0f0f9c;font-size: 12px;\r\n}\r\n.transcountignoredto{\r\n  background-color: rgb(203 203 203 / 69%);padding-block: 1px;border: 1px solid rgba(109, 109, 109, 0.69);font-size: 12px;\r\n  border-top-right-radius: 5px;\r\n  border-bottom-right-radius: 5px;\r\n}\r\n.transcountfailedyes{\r\n  background-color: #ff80804d;padding-block: 1px;border: 1px solid #6f0f0f9c;font-size: 12px;\r\n  border-bottom-right-radius: 5px;\r\n}\r\n.detailsrouteid{\r\n  border-right: 2px solid #00bcd4;\r\n}\r\n.agents{\r\n  border-right: 2px solid #00bcd4;\r\n}\r\n.datesdiv{\r\n  background-color: #ebebeb;\r\n}\r\n.datedivsize{\r\n  width: 21%;padding-left: 31px;\r\n}\r\n.datedivsizemod{\r\n  width: 21%;padding-left: 6%;\r\n}\r\n.transadiv{\r\n  color: #17a0b4; font-size: 12px;margin-top: 3px;\r\n}\r\n.countdate{\r\n  font-size: 12px;margin-left: 103px;\r\n}\r\n\r\n.countdatediv{\r\n  width: 100px;\r\n  text-align: center;\r\n  border: 1px solid #e6e6e6;\r\n  cursor: pointer;\r\n  text-decoration: underline;\r\n  padding: 15px;\r\n  background-color: #ebebeb;\r\n}\r\n.successmsgheaders{\r\n  width: 100.3px;\r\n  text-align: center;\r\n  border: 1px solid #e6e6e6;\r\n  padding: 15px;\r\n  background-color: #ebebeb;\r\n  font-size: 12px;\r\n}\r\n.msgtitle{\r\n  font-size: 12px;\r\n  width: 100px;\r\n  border: 1px solid #e6e6e6;\r\n  text-align: left;\r\n  padding: 15px;\r\n}\r\n\r\n.msgcountdiv{\r\n  width: 100px;\r\n  text-align: center;\r\n  border: 1px solid #e6e6e6;\r\n  padding: 15px;\r\n}\r\n::ng-deep.directiontabs .mat-tab-group.mat-primary .mat-ink-bar {\r\n  background-color: #17a0b4 !important;\r\n  height: 4px !important;\r\n  margin-left: auto;\r\n}\r\n::ng-deep.directiontabs .mat-tab-header{\r\n  height: 33px;\r\n}\r\n::ng-deep.directiontabs .mat-tab-label{\r\n  height: 31px !important;\r\n  text-transform: uppercase;\r\n}\r\n\r\n::ng-deep.directiontabs .mat-tab-label .mat-tab-label-content{\r\n  font-size: 12px !important;\r\n  font-weight: 600 !important;\r\n}\r\n  ::ng-deep.directiontabs .mat-tab-label.mat-ripple.mat-tab-label-active {\r\n      color: #17a0b4 !important;\r\n      background-color: white !important;\r\n      opacity: unset !important;\r\n      font-family: Montserrat;\r\n      .outbound_style {\r\n        .active_img {\r\n          display: block !important;\r\n          margin-right: 9px;\r\n          position: relative;\r\n          top: -2px;\r\n        }\r\n        .inactive_img {\r\n          display: none !important;\r\n        }\r\n      }\r\n      .inbound_style {\r\n        .active_img_inbound {\r\n          display: block !important;\r\n          margin-right: 11px;\r\n          position: relative;\r\n          top: -2px;\r\n        }\r\n        .inactive_img_inbound {\r\n          display: none !important;\r\n        }\r\n      }\r\n    }\r\n    .directionlist{\r\n      font-size: 11px;\r\n      font-family: Montserrat;\r\n\r\n    min-height: 66vh !important;\r\n    max-height: 66vh !important;\r\n    overflow-x: hidden !important;\r\n    overflow-y: auto !important;\r\n    }\r\n    .directionlistexp{\r\n      font-size: 11px;\r\n      font-family: Montserrat;\r\n\r\n    min-height: 47vh !important;\r\n    max-height: 47vh !important;\r\n    overflow-x: hidden !important;\r\n    overflow-y: auto !important;\r\n    }\r\n    .dedisplayname{\r\n    color: #17a0b4;\r\n    font-weight: bold;\r\n    border-right: 2px solid #00bcd4;\r\n    overflow: hidden;\r\n  text-overflow: ellipsis;\r\n  white-space: nowrap;\r\n    }\r\n\r\n    .dividerline{\r\n    background-color: #17a0b4;\r\n    height: 3px;\r\n    width: 100%;\r\n    margin-top: 10px;\r\n    }\r\n\r\n.highchart{\r\n  border: 2px solid #007887;\r\n    font-size: 12px;\r\n    min-height: 280px;\r\n    max-height: 280px;\r\n    margin-left:4%;\r\n}\r\n\r\n    .highcharts-figure,\r\n.highcharts-data-table table {\r\n  min-width: 310px;\r\n  max-width: 310px;\r\n  margin: 1em auto;\r\n}\r\n\r\n#container {\r\n  height: 200px;\r\n}\r\n\r\n.highcharts-data-table table {\r\n  font-family: Verdana, sans-serif;\r\n  border-collapse: collapse;\r\n  border: 1px solid #ebebeb;\r\n  margin: 10px auto;\r\n  text-align: center;\r\n  width: 100%;\r\n  max-width: 300px;\r\n}\r\n\r\n.highcharts-data-table caption {\r\n  padding: 1em 0;\r\n  font-size: 1.2em;\r\n  color: #555;\r\n}\r\n\r\n.highcharts-data-table th {\r\n  font-weight: 600;\r\n  padding: 0.5em;\r\n}\r\n\r\n.highcharts-data-table td,\r\n.highcharts-data-table th,\r\n.highcharts-data-table caption {\r\n  padding: 0.5em;\r\n}\r\n\r\n.highcharts-data-table thead tr,\r\n.highcharts-data-table tr:nth-child(even) {\r\n  background: #f8f8f8;\r\n}\r\n\r\n.highcharts-data-table tr:hover {\r\n  background: #f1f7ff;\r\n}\r\n.failresbody{\r\n  min-height: 255px;max-height: 255px;\r\n overflow-x: hidden !important;overflow-y: auto !important;\r\n  border-bottom: 2px solid #007887;\r\n  border-left: 2px solid #007887;\r\n  border-right: 2px solid #007887;\r\n  border-radius: 2px;\r\n}\r\n.failrestitle{\r\n  font-size: 12px;color: white;border-radius: 2px;\r\n}\r\n.failres{\r\n  overflow: hidden;\r\n  text-overflow: ellipsis;\r\n  white-space: nowrap;\r\n  text-decoration: underline;\r\n  cursor: pointer;\r\n}\r\n.failresdiv{\r\n  margin-left: 25px;padding-right: 33px;\r\n}\r\n.lockicon{\r\n  font-size: 18px;\r\n    color: #ff5d00;\r\n    height: auto;\r\n}\r\n.ids{\r\n  overflow: hidden;\r\ntext-overflow: ellipsis;\r\nwhite-space: nowrap;\r\nfont-size: 12px;\r\nfont-family: Montserrat;\r\nwidth: 36%;\r\npadding-left: 4%;\r\n}\r\n.vendorids{\r\n  overflow: hidden;\r\n  text-overflow: ellipsis;\r\n  white-space: nowrap;\r\n  font-size: 12px;\r\n  font-family: Montserrat;\r\n  width: 35%;\r\n}\r\n.vendoridsmail{\r\n  overflow: hidden;\r\n  text-overflow: ellipsis;\r\n  white-space: nowrap;\r\n  font-size: 12px;\r\n  font-family: Montserrat;\r\n  width: 36%;\r\n  padding-left: 34px;\r\n}\r\n.vendoridsph{\r\n  overflow: hidden;\r\n  text-overflow: ellipsis;\r\n  white-space: nowrap;\r\n  font-size: 12px;\r\n  font-family: Montserrat;\r\n  width: 36%;\r\n  padding-left: 4%;\r\n}\r\n.vendormaillabel{\r\n  padding-left: 8%;\r\n}\r\n.idspop{\r\n  overflow: hidden;\r\ntext-overflow: ellipsis;\r\nwhite-space: nowrap;\r\nfont-size: 12px;\r\nfont-family: Montserrat;\r\nwidth: 36%;\r\npadding-left: 1%;\r\n}\r\n.idsproc{\r\n  overflow: hidden;\r\ntext-overflow: ellipsis;\r\nwhite-space: nowrap;\r\nfont-size: 12px;\r\nfont-family: Montserrat;\r\nwidth: 42%;\r\npadding-left: 40px;\r\npadding-right: 80px;\r\n}\r\n.idsproj{\r\n  overflow: hidden;\r\ntext-overflow: ellipsis;\r\nwhite-space: nowrap;\r\nfont-size: 12px;\r\nfont-family: Montserrat;\r\nwidth: 42%;\r\npadding-left: 7%;\r\n}\r\n.idslab{\r\noverflow: hidden;\r\ntext-overflow: ellipsis;\r\nwhite-space: nowrap;\r\nfont-size: 12px;\r\nfont-family: Montserrat;\r\nwidth: 38%;\r\npadding-left: 77px;\r\npadding-right: 6%;\r\n}\r\n.pipelineidsdiv{\r\n  overflow: hidden;\r\n  text-overflow: ellipsis;\r\n  white-space: nowrap;\r\n  font-size: 12px;\r\n  font-family: Montserrat;\r\n  width: 38%;\r\n  padding-right: 6%;\r\n  padding-left: 54px;\r\n\r\n  }\r\n.idsfac{\r\n  overflow: hidden;\r\ntext-overflow: ellipsis;\r\nwhite-space: nowrap;\r\nfont-size: 12px;\r\nfont-family: Montserrat;\r\nwidth: 34%;\r\npadding-left: 26px;\r\n}\r\n.projlabel{\r\n  padding-left: 28px;\r\n}\r\n.fontcolr{\r\n  color: #17a0b4;\r\n}\r\n.failresbodypop{\r\n  // min-height: 263px;max-height: 263px;\r\n  overflow-x: hidden !important;\r\n  overflow-y: auto !important;\r\n  border-bottom: 2px solid #007887;\r\n  border-left: 2px solid #007887;\r\n  border-right: 2px solid #007887;\r\n  min-height: 278px;\r\n  max-height: 278px;\r\n}\r\n.successresbody{\r\n  min-height: 255px;max-height: 255px;\r\n  border-bottom: 2px solid #007887;\r\n  border-left: 2px solid #007887;\r\n  border-right: 2px solid #007887;\r\n  border-radius: 2px;\r\n}\r\n\r\n.successreslist{\r\n  overflow-x: hidden !important;overflow-y: auto !important;\r\n  min-height: 232px;max-height: 232px;\r\n}\r\n.failurelistheader{\r\n  background-color: #007887;font-size: 12px;color: white;font-family: Montserrat;\r\n}\r\n\r\n::ng-deep.failresbodypop .mat-checkbox-frame{\r\n  border: 1px solid #007887;\r\n}\r\n::ng-deep.failresbodypop .mat-checkbox-inner-container {\r\n  height: 15px;\r\n}\r\n::ng-deep.failurelistheader .mat-checkbox-frame{\r\n  border: 1px solid #007887;\r\n}\r\n::ng-deep.failurelistheader .mat-checkbox-inner-container {\r\n  height: 15px;\r\n  background-color: white;\r\n}\r\n.reprobtn{\r\n  background-color: #007887;font-size: 12px;color: white;font-family: Montserrat;cursor: pointer;\r\n}\r\n.popupdate{\r\n  border-left: 2px solid #00bcd4;\r\n  border-right: 2px solid #00bcd4;\r\n}\r\n.reason{\r\n  // overflow: hidden;\r\n  // text-overflow: ellipsis;\r\n  // white-space: nowrap;\r\n  font-size: 13px;\r\n  color: #17a0b4;\r\n  font-weight: bold;\r\n  font-family: Montserrat;\r\n  // width: 23%;\r\n}\r\n.headercheckbox{\r\n  padding-left: calc(1vw + 3px);\r\n}\r\n.chevronleft{\r\n    line-height: 36px;\r\n    top: 14px;\r\n    position: relative;\r\n}\r\n.chevronleftbtnact{\r\n  background-color: green;color: white;margin-left: 1%;\r\n}\r\n.chevronleftbtninact{\r\n  background-color: red;color: white;margin-left: 1%;\r\n}\r\n.failresheader{\r\nbackground-color: #007887;\r\n}\r\n.countdateheader{\r\n  background-color: #007887;\r\n  height: 22px;\r\n  width: 100%;\r\n  margin-left: 0px;\r\n}\r\n.modal .modalsize{\r\n  max-width: 90% !important;\r\n}\r\n::ng-deep.idsexpdiv .idsacc .mat-expansion-panel-body {\r\n  padding: 5px !important;\r\n  background-color: #ebebeb !important;\r\n  font-size: 12px;\r\n}\r\n.msgcountday{\r\n  background-color: #17a2b8;\r\n  color: white;\r\n}\r\n\r\n.main {\r\n  // top: 26%;\r\n  //   left: 13%;\r\n  height: 17px;\r\n  border-radius: 0 0 100px 100px;\r\n  border: 1px solid grey;\r\n  border-top: none;\r\n  background-clip: padding-box;\r\n  position: relative;\r\n  display: inline-block;\r\n  margin-right: 6px;\r\n  padding-inline: 3px;\r\n  position: relative;\r\n  top: 9px;\r\n  // padding-bottom: 3px;\r\n}\r\n\r\n.submain {\r\n  // top: 26%;\r\n  // left: 13%;\r\n  height: 17px;\r\n  border-radius: 0 0 100px 100px;\r\n  border: 1px solid grey;\r\n  border-top: none;\r\n  background-clip: padding-box;\r\n  position: relative;\r\n  display: inline-block;\r\n  margin-right: 6px;\r\n  padding-inline: 3px;\r\n  position: relative;\r\n  top: 9px;\r\n  // padding-bottom: 3px;\r\n}\r\n\r\n.main::after {\r\n  content: \"\";\r\n  position: absolute;\r\n  left: 100%;\r\n  right: 1px;\r\n  height: 1px;\r\n  border-top: 1px solid grey;\r\n  width: 33%;\r\n  display: inline;\r\n  top: 0;\r\n}\r\n.img_space {\r\n  height: 23px;\r\n  position: relative;\r\n  top: -12px;\r\n}\r\n.varulebtn{\r\n  height: 23px !important;\r\n}\r\n.connheadersdef{\r\n  bottom: 7%;\r\n  position: relative;\r\n  background-color: #ebebeb;\r\n  color: black;\r\n  border: 1px solid;\r\n  border-radius: 1px;\r\n  left: 14%;\r\n  width: 70%;\r\n}\r\n.details2{\r\n  background-color: white;\r\n  overflow-x: hidden !important;overflow-y: auto !important;min-height:64vh;max-height: 64vh;\r\n}\r\n::ng-deep.connec .mat-tab-label{\r\n  min-width: 16.66% !important;\r\n  max-width: 16.66% !important;\r\n  border-right: 2px solid #ebebeb !important;\r\n}\r\n::ng-deep.interface .Failed{\r\n  min-width: 16.66% !important;\r\n  max-width: 16.66% !important;\r\n  border-right: 2px solid #ebebeb !important;\r\n  background-color: red ;\r\n  color: white;\r\n}\r\n::ng-deep.connec .Success.mat-tab-label{\r\n  min-width: 16.66% !important;\r\n  max-width: 16.66% !important;\r\n  border-right: 2px solid #ebebeb !important;\r\n  background-color: green !important;\r\n  color: white !important;\r\n}\r\n::ng-deep.connec .default .mat-tab-label{\r\n  min-width: 16.66% !important;\r\n  max-width: 16.66% !important;\r\n  border-right: 2px solid #ebebeb !important;\r\n}\r\n::ng-deep.connec .mat-tab-group.mat-primary .mat-ink-bar {\r\n  background-color: #17a0b4 !important;\r\n  height: 4px !important;\r\n  margin-left: auto;\r\n}\r\n\r\n.stepper-wrapper {\r\n  display: flex;\r\n  justify-content: space-between;\r\n  height: 82vh;\r\n  overflow-x: hidden;\r\n}\r\n.stepper-item {\r\n  position: relative;\r\n  font-size: 11px;\r\n  display: flex;\r\n  flex-direction: column;\r\n  align-items: center;\r\n  flex: 1;\r\n  background-color: #ebebeb;\r\n  border: 2px solid #c8c5c538;\r\n  min-width: 16.66%;\r\n  max-width: 16.66%;\r\n}\r\n.cursor {\r\n  cursor: pointer;\r\n}\r\n\r\n\r\n\r\n.seqheader{\r\n  min-width: 16.66% !important;\r\n  max-width: 16.66% !important;\r\n  border: 2px solid #ebebeb !important;\r\n  height: 33px;\r\n  padding: 5px;\r\n  text-align: center;\r\n  opacity: 0.5;\r\n}\r\n.seqheaderActive{\r\n  opacity: unset;\r\n  box-shadow: 1px 0px 7px 1px grey;\r\n}\r\n.Failed{\r\n  background-color:#f59598 !important;\r\n  color: white !important;\r\n}\r\n.Success{\r\n  background-color:#90cfb5 !important;\r\n  color: white !important;\r\n}\r\n.default{\r\n  min-width: 16.66% !important;\r\n  max-width: 16.66% !important;\r\n  border: 2px solid #ebebeb !important;\r\n  height: 33px;\r\n  padding: 5px;\r\n  text-align: center;\r\n  opacity: 0.5;\r\n}\r\n\r\n\r\n.seqbody{\r\n  overflow-x: hidden !important;\r\n  overflow-y: auto !important;\r\n  min-height:120px;\r\n  max-height: 120px;\r\n  background-color: #a9dad152;\r\n}\r\n.datediviconsize{\r\n  padding-left: 4%;\r\n  width: 14%;\r\n}\r\n.form-control{\r\n  border-radius: 5px !important;\r\n  font-size: 11px !important;\r\n}\r\n\r\n//Datavalidation style part\r\n\r\n.failurelistheader1{\r\n  font-size: 12px;color: black;font-family: Montserrat;\r\n}\r\n\r\n.mat-mdc-table {\r\n  width: 100%;\r\n  max-height: 100px;\r\n  overflow: auto;\r\n}\r\n\r\n.mat-column-name {\r\n  height: 100px;\r\n}\r\n\r\n\r\n.datavalidtableheader {\r\n  position: sticky;\r\n  top: 0;\r\n  background-color:#0e6470;\r\n  z-index: 1;\r\n  color: white;\r\n  height: 23px;\r\n  display: flex;\r\n  justify-content: center;\r\n  align-items: center;\r\n}\r\n\r\n.content-row {\r\n  margin-top: 30px; /* Adjust the margin as needed */\r\n}\r\n.even-row {\r\n  background-color: #F0F0F0;\r\n}\r\n\r\n.odd-row {\r\n  background-color: #FFFFFF;\r\n}\r\n.even-row,\r\n.odd-row {\r\n  height: 33px;\r\n  display: flex;\r\n  justify-content: center;\r\n  align-items: center;\r\n}\r\n\r\n.container::-webkit-scrollbar {\r\n  width: 8px;\r\n  background-color: #f5f5f5;\r\n}\r\n\r\n.mat-form-field-appearance-outline .mat-form-field-infix {\r\n  width: 221px;\r\n}\r\n\r\n.callsplit\r\n{\r\n  margin-right: 5px;\r\n  color:#f44455;\r\n}\r\n.scrollable-content {\r\n  position: absolute;\r\n  top: 20px; /* Adjust this value to match the height of the sticky row */\r\n  bottom: 0;\r\n  left: 0;\r\n  right: 0;\r\n  overflow-x: hidden;\r\n  //background-color: royalblue;\r\n}\r\n\r\n::ng-deep .ValidationPopupScreen .modal-dialog {\r\n  max-width: 80%;\r\n  max-height: 60% !important;\r\n  height: 60% !important;\r\n  margin: auto !important;\r\n  padding: 0 !important;\r\n}\r\n\r\n.Header_row{\r\n  background:#007887; \r\n  margin-inline: -0.5px; \r\n  color: white\r\n}\r\n/* Add the styles for the scrolling div */\r\n.card-scroll {\r\n  height: 387px; /* Adjust the height as needed */\r\n  overflow-x: hidden;\r\n}\r\n\r\n.selected{\r\n  background-color: #B8FAFF; /* Add your desired background color for the selected card */\r\n}\r\n\r\n.isCompletedStatus {\r\n  cursor: pointer;\r\n}\r\n.visibility_off{\r\n  color: #17a2b8;\r\n  height: 19px !important;\r\n  width: 19px !important;\r\n  font-size: 19px;\r\n  padding-left: 13px;\r\n  position: relative;\r\n  top: 1px;\r\n  cursor: pointer; \r\n}\r\n.visibility{\r\n  color: #17a2b8;\r\n  height: 19px !important;\r\n  width: 19px !important;\r\n  font-size: 19px;\r\n  cursor: pointer;\r\n}\r\n.failrow .msgtitle{\r\n  background-color: #ffc3c3;\r\n}\r\n.failrow .msgcountdiv{\r\n  background-color: #ffc3c3;\r\n}\r\n.ignorerow .msgtitle{\r\n  background-color: #fffdbe;\r\n}\r\n.ignorerow .msgcountdiv{\r\n  background-color: #fffdbe;\r\n}\r\n.successrow .msgtitle{\r\n  background-color: #c4fba0;\r\n}\r\n.successrow .msgcountdiv{\r\n  background-color: #c4fba0;\r\n}\r\n.resolvedrow .msgtitle{\r\n  background-color: #c6ecff;\r\n}\r\n.resolvedrow .msgcountdiv{\r\n  background-color: #c6ecff;\r\n}\r\n.datedivpop{\r\n  border: 1px solid #C0C0C0;\r\n  background-color: white;\r\n  border-radius: 5px;\r\n  height: 24px;\r\n  width: 49%;\r\n}\r\n.toinputpop{\r\nborder:transparent;\r\nfont-size: 12px;\r\nheight: 20px;\r\n}\r\n.frominputpop{\r\n  border:transparent;\r\n  font-size: 12px;\r\n  height: 20px;\r\n  }\r\n  .datesearchpopbtn{\r\n    background-color: #59a7b1;\r\n    color: white;\r\n    height: 24px;\r\n    width: 28px;\r\n    padding-left: 1px;\r\n  }\r\n  .copy_iconss{\r\n    background-repeat: no-repeat;\r\n      display: inline-block;\r\n      fill: currentColor;\r\n      font-size: 16px;\r\n      position: relative;\r\n      top: 8%;\r\n      left: 2%;\r\n      cursor: pointer;\r\n  }\r\n  .mat-icon-button ::ng-deep .mat-button-focus-overlay {\r\n    display: none;\r\n}\r\n::ng-deep.myint.mat-mdc-checkbox {\r\n  height: 16px;\r\n  width: 16px;\r\n  position: relative;\r\n  right: 100%;\r\n  bottom: 42%;\r\n  .mdc-checkbox {\r\n    width: 14px;\r\n    height: 14px;\r\n    .mdc-checkbox__native-control:enabled:checked~.mdc-checkbox__background{\r\n      border-color: $btn-color;\r\n      background-color: $btn-color;\r\n    }\r\n    .mdc-checkbox__native-control:enabled~.mdc-checkbox__background .mdc-checkbox__checkmark {\r\n      color: white;\r\n  }\r\n  }\r\n  .mdc-checkbox__background{\r\n    height: 16px;\r\n    width: 16px;\r\n  }\r\n}\r\n.msgmodaldata{\r\n  min-height: 55vh !important;\r\n  max-height: 55vh  !important;\r\n  overflow-x: hidden !important;\r\n  overflow-y: auto  !important;\r\n}\r\n::ng-deep.moreicon .mat-mdc-button-persistent-ripple{\r\ndisplay: none !important;\r\n}\r\n\r\n.autocomplete-dropdown {\r\n  position: absolute;\r\n  background-color: #fff;\r\n  border: 1px solid #ccc;\r\n  max-height: 200px;\r\n  overflow-y: auto;\r\n  // width: 119vh;\r\n  z-index: 1000;\r\n  border-radius: 6px !important;\r\n}\r\n\r\n.autocomplete-dropdown ul {\r\n  list-style-type: none;\r\n  padding: 0;\r\n  margin: 0;\r\n  color: black;\r\n}\r\n\r\n.autocomplete-dropdown li {\r\n  padding: 8px;\r\n  cursor: pointer;\r\n}\r\n\r\n.autocomplete-dropdown li:hover {\r\n  background-color: #f0f0f0;\r\n}\r\n\r\n.input-wrapper {\r\n  position: relative;\r\n  display: flex;\r\n  align-items: center;\r\n}\r\n\r\n.loading-spinner {\r\n  position: absolute;\r\n  top: 50%;\r\n  right: 10px; \r\n  transform: translateY(-50%);\r\n  pointer-events: none; \r\n}\r\n\r\n.mat-spinner {\r\n  width: 20px;  \r\n  height: 20px;\r\n}\r\n\r\n.pipeline_feild .autocomplete-container .x {\r\n  display: none;\r\n}\r\n\r\n.clear-icon {\r\n  position: absolute;\r\n  right: 0%;\r\n  cursor: pointer;\r\n  color: rgba(0, 0, 0, 0.54);\r\n  top: 20%;\r\n  font-size: 18px !important;\r\n}\r\n\r\n// .loading-spinner {\r\n//   display: flex;\r\n//   align-items: center;\r\n//   margin-top: 5px;\r\n//   font-size: 14px;\r\n//   color: #888;\r\n// }\r\n\r\n// .successborder {\r\n//   color: green;\r\n// }\r\n\r\n// .dangerborder {\r\n//   color: red;\r\n// }\r\n.redirectlink{\r\n\r\n}\r\n.redirectlink:hover{\r\n  background-color: #3fa4fb;\r\n    border-radius: 12px;\r\n    color: white;\r\n    padding: 3px;\r\n    cursor: pointer;\r\n    height: 21px;\r\n}\r\n.interfacepagination{\r\n  .mat-mdc-paginator{\r\n    background-color: #f1f1f1 !important;\r\n  }\r\n}\r\n\r\n.pinned-section {\r\n  margin-top: 10px;\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: 8px;\r\n}\r\n\r\n.pinned-card {\r\n  border-left: 4px solid #2196f3;\r\n  background-color: #f7f9fc;\r\n  transition: all 0.3s ease;\r\n}\r\n\r\n.pinned-card:hover {\r\n  background-color: #eaf2fb;\r\n}\r\n\r\n.child-card-section {\r\n  margin-left: 30px;           /* visually nested */\r\n  border-left: 3px solid #cfd8dc;\r\n  padding-left: 10px;\r\n  margin-top: 5px;\r\n}\r\n\r\n.child-card {\r\n  background: #ffffff;         /* subtle gray background */\r\n  border-radius: 6px;\r\n  border: 1px solid #e0e0e0;   /* thin border to separate rows */\r\n  margin-bottom: 4px;\r\n  transition: all 0.3s ease;\r\n}\r\n\r\n.child-card:hover {\r\n  background: #f1f1f1;\r\n}\r\n\r\n.child-card .row {\r\n  font-size: 13px;\r\n  color: #333;\r\n}\r\n\r\n.child-card b {\r\n  color: #007bff;\r\n}\r\n\r\n.childexpcard{\r\n  background-color:#f9f9f9; \r\n  margin-bottom: 0; \r\n  padding-top: 5px;\r\n  min-height: 13vh;\r\n  max-height: 23vh;\r\n  overflow-x: hidden;\r\n  overflow-y: auto;\r\n}\r\n\r\n.searchkey{\r\n  white-space: nowrap;  position: relative; z-index: 1000;\r\n  color: #4b86b2;\r\n}\r\n.searchkey:hover{\r\n  background-color: #3fa4fb;\r\n    border-radius: 12px;\r\n    color: white;\r\n    padding: 3px;\r\n    cursor: pointer;\r\n    white-space: nowrap;\r\n    position: relative; z-index: 1000;\r\n}\r\n\r\n.expander-icon {\r\n  color: #ffffff !important;\r\n  font-size: 20px !important;\r\n  width: 20px !important;\r\n  height: 20px !important;\r\n  display: inline-block !important;\r\n  line-height: 20px !important;\r\n  position: relative !important;\r\n  z-index: 100 !important;\r\n}\r\n\r\n.addconfigbtn {\r\n  overflow: visible !important;\r\n  \r\n  .expander-icon {\r\n    z-index: 100 !important;\r\n  }\r\n}\r\n::ng-deep.myCustomModalClassciisint .modal-dialog {\r\n  max-width: 97%;\r\n  max-height: 60%;\r\n  height: 60%;\r\n  margin: auto;\r\n  padding: 0 !important;\r\n}\r\n\r\n// Pin icon container for vertical layout (icon + text)\r\n.pin-icon-container {\r\n  width: 60px;\r\n  height: 42px;\r\n  display: flex;\r\n  flex-direction: column;\r\n  align-items: center;\r\n  justify-content: center;\r\n  gap: 2px;\r\n  cursor: pointer;\r\n}\r\n\r\n// Pin icon styling\r\n.pin-icon {\r\n  color: #17a0b4 !important;\r\n  font-size: 20px !important;\r\n  width: 20px !important;\r\n  height: 20px !important;\r\n  line-height: 20px !important;\r\n  display: inline-block !important;\r\n}\r\n\r\n// Pin label text styling\r\n.pin-label {\r\n  color: #17a0b4;\r\n  font-size: 10px;\r\n  white-space: nowrap;\r\n  line-height: 1.2;\r\n  font-family: Montserrat, sans-serif;\r\n}\r\n// Pipeline mat-menu: consistent icon + label alignment\r\n.interface-menu-item-inline {\r\n  display: flex !important;\r\n  flex-direction: row !important;\r\n  align-items: center !important;\r\n  justify-content: flex-start !important;\r\n  flex-wrap: nowrap !important;\r\n  min-height: 40px !important;\r\n}\r\n.interface-menu-item-inline__row {\r\n  display: flex;\r\n  flex-direction: row;\r\n  align-items: center;\r\n  flex-wrap: nowrap;\r\n  width: 100%;\r\n  min-width: 0;\r\n  gap: 12px;\r\n}\r\n.interface-menu-item-inline__icon-slot {\r\n  width: 20px;\r\n  height: 20px;\r\n  flex-shrink: 0;\r\n  display: inline-flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n\r\n  mat-icon {\r\n    font-size: 20px;\r\n    width: 20px;\r\n    height: 20px;\r\n    line-height: 20px;\r\n    color: #007887;\r\n  }\r\n\r\n  svg,\r\n  img {\r\n    width: 16px;\r\n    height: 16px;\r\n    display: block;\r\n    color: #007887;\r\n    fill: currentColor;\r\n    object-fit: contain;\r\n  }\r\n}\r\n.interface-menu-item-inline__icon {\r\n  flex-shrink: 0;\r\n  color: #007887;\r\n  display: block;\r\n}\r\n.interface-menu-item-inline__label {\r\n  font-size: 12px;\r\n  white-space: nowrap;\r\n  line-height: 1.2;\r\n}\r\n\r\n::ng-deep .interface-pipeline-menu {\r\n  .mat-mdc-menu-item {\r\n    min-height: 40px;\r\n    padding-inline: 12px;\r\n  }\r\n\r\n  .mat-mdc-menu-item-text {\r\n    display: flex;\r\n    align-items: center;\r\n    width: 100%;\r\n  }\r\n}\r\n\r\n/* --- ADDED (does not remove or edit the existing .details2 / .directionlist rules above) ---\r\n   Nested scroll surfaces (e.g. agent/detail area .details2) sit inside the tab shell.\r\n   Global locks on .mat-drawer-content alone do not stop these; use :host-context so we win\r\n   over local !important overflow rules when a child overlay is open\r\n   (VA Rules = NgbModal, Delivery rules = MatDialog). */\r\n:host-context(body.modal-open) .details2,\r\n:host-context(body.app-main-scroll-locked) .details2,\r\n:host-context(html.cdk-global-scrollblock) .details2,\r\n:host-context(body.modal-open) .directionlist,\r\n:host-context(body.app-main-scroll-locked) .directionlist,\r\n:host-context(html.cdk-global-scrollblock) .directionlist,\r\n:host-context(body.modal-open) .directionlistexp,\r\n:host-context(body.app-main-scroll-locked) .directionlistexp,\r\n:host-context(html.cdk-global-scrollblock) .directionlistexp {\r\n  overflow: hidden !important;\r\n}","$btn-color: #17a0b4 !important;\r\n$fontsize: 12px !important;\r\n$btntextcolor: white !important;\r\n$btnHeight: 28px !important;\r\n$inputHeight:30px !important;\r\n$inputfontsize:11px !important;\r\n$primary:#004bff;\r\n// $modalHeaderTitleFont: ;\r\n@mixin modalheaderTtext {\r\n  font-size: 14px;\r\n  font-weight: 600;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
